webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(243),
  /* template */
  __webpack_require__(186),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(253),
  /* template */
  __webpack_require__(185),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export STORAGE_KEY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CRUMB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return WRITE_CRUMB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return READ_CRUMB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CLEAN_CRUMB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return WORKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return WRITE_WORKS; });
/* unused harmony export READ_WORKS */
/* unused harmony export MODIDY_WORKS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CLEAN_WORKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return USER; });
/* unused harmony export READ_USER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return WRITE_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CLEAN_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SUBJECT; });
/* unused harmony export READ_SUBJECT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return WRITE_SUBJECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CLEAN_SUBJECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TOAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return WRITE_TOAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CLEAN_TOAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CATALOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return WRITE_CATALOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLEAN_CATALOG; });
var STORAGE_KEY = 'xxwl';
var CRUMB = 'crumb';
var WRITE_CRUMB = 'write_crumb';
var READ_CRUMB = 'read_crumb';
var CLEAN_CRUMB = 'clean_crumb';
var WORKS = 'works';
var WRITE_WORKS = 'write_works';
var READ_WORKS = 'read_works';
var MODIDY_WORKS = 'modify_works';
var CLEAN_WORKS = 'clean_works';
var USER = 'user';
var READ_USER = 'read_user';
var WRITE_USER = 'write_user';
var CLEAN_USER = 'clean_user';
var SUBJECT = 'subject';
var READ_SUBJECT = 'read_subject';
var WRITE_SUBJECT = 'write_subject';
var CLEAN_SUBJECT = 'clean_subject';
var TOAST = 'toast';
var WRITE_TOAST = 'write_toast';
var CLEAN_TOAST = 'clean_toast';
var CATALOG = 'catalog';
var WRITE_CATALOG = 'write_catalog';
var CLEAN_CATALOG = 'clean_catalog';

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(178),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(181),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(177),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(182),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(179),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(252),
  /* template */
  __webpack_require__(194),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["nowDate"] = nowDate;
/* harmony export (immutable) */ __webpack_exports__["timeStamp"] = timeStamp;
/* harmony export (immutable) */ __webpack_exports__["aroundDate"] = aroundDate;
/* harmony export (immutable) */ __webpack_exports__["formatDate"] = formatDate;
/* harmony export (immutable) */ __webpack_exports__["formatDataToMinutes"] = formatDataToMinutes;
/* harmony export (immutable) */ __webpack_exports__["formatDataToMinute"] = formatDataToMinute;
/* harmony export (immutable) */ __webpack_exports__["timeAxis"] = timeAxis;
/* harmony export (immutable) */ __webpack_exports__["closeDateState"] = closeDateState;
/* harmony export (immutable) */ __webpack_exports__["closeDate"] = closeDate;
/* harmony export (immutable) */ __webpack_exports__["countDownDate"] = countDownDate;
/* harmony export (immutable) */ __webpack_exports__["countLast"] = countLast;
/* harmony export (immutable) */ __webpack_exports__["stringParam"] = stringParam;
/* harmony export (immutable) */ __webpack_exports__["compareDate"] = compareDate;
/* harmony export (immutable) */ __webpack_exports__["parseParam"] = parseParam;
/* harmony export (immutable) */ __webpack_exports__["gradText"] = gradText;
/* harmony export (immutable) */ __webpack_exports__["formatHtml"] = formatHtml;
/* harmony export (immutable) */ __webpack_exports__["fromCharCode"] = fromCharCode;
/* harmony export (immutable) */ __webpack_exports__["setAssess"] = setAssess;
/* harmony export (immutable) */ __webpack_exports__["toMath"] = toMath;
/* harmony export (immutable) */ __webpack_exports__["toPercent"] = toPercent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

function nowDate(date) {
    return date ? new Date(date) : new Date();
}
/*
    转化成时间戳
    返回（s）秒
*/
function timeStamp(date) {
    date = Date.parse(nowDate(date));
    return date / 1000;
}
/*
    日期加减
*/
function aroundDate(date, num) {
    date = nowDate(date);
    date.setDate(date.getDate() + num);
    return date;
}

function formatDate(date, format) {
    if (!date) {
        return false;
    }
    date = nowDate(date * 1000);

    var obj = {
        'y+': date.getFullYear(),
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds(),
        'W+': date.getDay()
    };
    var weeks = ['日', '一', '二', '三', '四', '五', '六'];
    obj['W+'] = '周' + weeks[obj['W+']];
    if (new RegExp("(y+)").test(format)) {
        format = format.replace(RegExp.$1, obj['y+']);
    }
    for (var j in obj) {
        if (new RegExp("(" + j + ")").test(format)) {
            format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? obj[j] : ("00" + obj[j]).substr(("" + obj[j]).length));
        }
    }
    return format;
}

function formatDataToMinutes(data) {
    return Math.ceil(data / 60);
}
function formatDataToMinute(data) {
    return Math.ceil(data / 60);
}

function timeAxis(date, currentTime) {
    // debugger
    var timestampDiff = (currentTime - date) / 60 / 60 / 24;
    var res = '';
    var currentDate = nowDate(currentTime * 1000);
    var times = formatDate(date, 'hh:mm');
    if (timestampDiff > 0) {
        if (timestampDiff < 1 && currentDate.getMonth() == nowDate(date * 1000).getMonth() && currentDate.getDate() == nowDate(date * 1000).getDate()) {
            res = '今天 ' + times;
        } else if (timestampDiff < 2 && currentDate.getMonth() == nowDate(date * 1000).getMonth() && currentDate.getDate() == nowDate(date * 1000).getDate() + 1) {
            res = '昨天 ' + times;
        } else if (timestampDiff < 3 && currentDate.getMonth() == nowDate(date * 1000).getMonth() && currentDate.getDate() == nowDate(date * 1000).getDate() + 2) {
            res = '前天 ' + times;
        } else {
            res = formatDate(date, 'MM-dd') + ' ' + times;
        }
    } else if (timestampDiff < 0) {
        if (timestampDiff > -1 && currentDate.getMonth() == nowDate(date * 1000).getMonth() && currentDate.getDate() == nowDate(date * 1000).getDate()) {
            res = '今天 ' + times;
        } else if (timestampDiff > -2 && currentDate.getMonth() == nowDate(date * 1000).getMonth() && currentDate.getDate() == nowDate(date * 1000).getDate() - 1) {
            res = '明天 ' + times;
        } else if (timestampDiff > -3 && currentDate.getMonth() == nowDate(date * 1000).getMonth() && currentDate.getDate() == nowDate(date * 1000).getDate() - 2) {
            res = '后天 ' + times;
        } else {
            res = formatDate(date, 'MM-dd') + ' ' + times;
        }
    }
    return res;
}

function closeDateState(currentTime, publishDate, effectiveDate) {
    // let currentDate = timeStamp();
    // let timestampDiff = (currentDate - date) / 24 / 60 / 60;
    var res = '';
    if (currentTime < publishDate) {
        res = 1;
    } else if (currentTime > effectiveDate) {
        res = -1;
    } else {
        res = 0;
    }
    return res;
}

function closeDate(currentTime, publishDate, effectiveDate) {
    var state = closeDateState(currentTime, publishDate, effectiveDate);

    var res = '';

    switch (state) {
        case 1:
            res = '发布时间还剩: ' + countDownDate(currentTime, publishDate);
            break;
        case 0:
            res = '结束时间还剩: ' + countDownDate(currentTime, effectiveDate);
            break;
        default:
            res = '';
    }
    return res;
}

function countDownDate(currentTime, date) {
    var timestampDiff = currentTime - date;
    var res = '';

    timestampDiff = timestampDiff < 0 ? timestampDiff * -1 : timestampDiff;

    if (timestampDiff < 3600) {
        res = Math.floor(timestampDiff / 60) + '分';
    } else if (timestampDiff < 3600 * 24) {
        res = Math.floor(timestampDiff / 3600) + '小时' + Math.floor(timestampDiff / 60 % 60) + '分';
    } else if (timestampDiff > 3600 * 24) {
        res = Math.floor(timestampDiff / 3600 / 24) + '天' + Math.floor(timestampDiff / 3600 % 24) + '小时' + Math.floor(timestampDiff / 60 % 60) + '分';
    }
    return res;
}

function countLast(date) {
    var currentDate = timeStamp();
    var timestampDiff = currentDate - date;
    var res = '';

    timestampDiff = timestampDiff < 0 ? timestampDiff * -1 : timestampDiff;
    if (timestampDiff < 86400 && nowDate().getMonth() == nowDate(date * 1000).getMonth() && nowDate().getDate() == nowDate(date * 1000).getDate()) {
        res = '今天';
    } else if (timestampDiff < 86400 * 2 && nowDate().getMonth() == nowDate(date * 1000).getMonth() && nowDate().getDate() == nowDate(date * 1000).getDate() + 1) {
        res = '昨天';
    } else {
        var lastDays = Math.ceil(timestampDiff / 86400);
        res = lastDays + '天前';
    }
    return res;
}

function stringParam(obj) {
    var res = "";
    for (var k in obj) {
        res += '&' + k + '=' + obj[k];
    }
    return res.slice(1);
}

function compareDate(date) {
    var res = date - timeStamp();
    return res >= 0 ? true : false;
}

function parseParam(url) {
    var arr = '';
    var obj = {};
    url = url || window.location.href;
    if (url.split("?").length > 1) {
        arr = url.split('?')[1].split('&');
        arr.map(function (item) {
            item = item.split('=');
            var k = item[0],
                v = item[1];
            obj[k] = v;
        });
        return obj;
    }
}

function gradText(num) {
    var data = __webpack_require__(257);
    var res = '';
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(data.default), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            if (item.id == num) {
                res = item.name;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return res;
}
// 格式化题干html
function formatHtml(val, type) {
    if (type == 3) {
        return val.replace(/{#blank#}(\d*){#\/blank#}/g, '<span class="filling-txt"><i class="filling_bg">$1</i></span>');
    } else {
        return val.replace(/&nbsp;/g, ' ');
    }
}
// 数字转成字母
function fromCharCode(val) {
    return String.fromCharCode(65 + val);
}
// 设置得分(assess= undefined或6:未作答  0:未批改 1:对 2:错 3:半对 4:未知  5:批改失败)
function setAssess(userAnswer) {
    var html = '';
    if (userAnswer && userAnswer.score !== undefined) {
        if (userAnswer.assess === 0) {
            html = '评分中';
        } else if (userAnswer.assess === 5) {
            html = '批改失败';
        } else {
            html = parseFloat(userAnswer.score) + '分';
        }
    } else {
        html = 0 + '分';
    }
    return html;
}

function toMath(num, count, defaultValue) {

    if (num == 0) {
        return 0;
    } else if (num == "-" || !num) {
        return num = "-";
    }
    return num = parseFloat(parseFloat(num).toFixed(count));
}
function toPercent(num, count, defaultValue) {

    if (num == 0) {
        return 0;
    } else if (num == "-" || !num) {
        return num = "-";
    }

    return num = Number(num * 100).toFixed(count) + "%";
}

/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAYAAABXuSs3AAAEQElEQVRogcWZa4gWVRjHfzu1u+22ZJobZGZWtGR5qTAq7WIXulIU0gXKFCViKfNDEVFBYB+6gpAgfWhBISgtIqMUQikhyFWyMlo3NS206MJeNFbLzf59OO/EdPbMvOfMHLc/PLyc8z6X38ycmTnnTIMkImgOcAUwFTgXaAfagAQYAvqAvUAP8BmwAThUpWBDBfArgQeA64HJgbF9GPg3gbWlqksKteskva142iRpbihHiPN0SVsjAtvaIelmXx7fofIIsNzDbx/wNbAbGKj1tQAdwJTab0OdHMuBR+tW8ji6FQVnqU/SGklLJE2R1FAn1yRJiyStkrSrIO/7ktqLchUVaZS0uSD5i5LG+F7aHFsi6Y+c/D9LOqsM+Oc5CTdLurwicNbOkLlqLvWHgr+ek+iliMC2PZZTc60v+OKcBA8eQ+jUrsqp3VUPfFJO4KJRgE5tdg7DjUXgOx0Br4widGoLHRxDkppd4Fc7nHv+B+jU3nHw/Dtcs44bHY4dAYVelfRyRPAmScMWzz4b/BIHdMgQacrEfSQzTmPA3+fguj8Lvtr6czCwwAkyL4ysno4E32fl3Z6CN8oM/KzWBCZvlvSL4+yslDS2Irjr5XRmAtwKtFpTmA0eEyofzQf2AE9WyLHC0XcvkpY5jmhCpDOeVZcyj7NA67dyfZAAF1hHsxv4qcIZytNCoBeYXSK222qflmDWiFltLUPlqcnAp5jL3xgQt81qn5QA463OveW5vNUJ7ABmevr/aLVbE0auSA5XpfLUOZiru9jD91er3ZIAR63O5hhUAVrg4XPAajcmwBGrsyUKjp/eA2Z5+LVZ7eEE6Lc6T4+CVKxDwFLgTuBPD/+JdvzxmJuxI9N5YRy2XG3BAIc8cm2mAwmw0+o8DxhXAaxIq4BLCX9PXGa1DybAJofj7WWoCjQAzMPvRrR1NnC+1bclAdYBf1l/zClRIE8bMW/nN0rGP+zoW53OBdZbc4EfIs1Vni05N8nat1bOAWXm4zc4inYGJLfn47skzYsAPcPB9VwWHEnfOJxaPQtkV0ArJR0XARqNXLwflXSiDX63A/zdgCKvyaw7YwAj6XEHz7L0/6xjIuk3h/NDEWF87VoHhySNc4Ej6ZqcgGmjCN0m6XcHw3/WsK7ALkfQ0CjBnyyzwW/rS9s3L8EnjuBhSfOPIfQdkvY76vbWDsgLfIykw44kkrkJmyJDP5NTS5ImumKKks3QyD2NVN9LuiUC8CxJ3QXQd+XF1kt8iqSPCxL3ylyBmQGw02R2yb4qyPudpKlFeXw/Xr0F3FPHpwfYDnyBWSP2A38DY4EJwPSaXVQnTzdwEzBY6BVwpjrlfkzF0rCkpb48oWPyVElPyH33l9VBSc/LfFTwZil7UzVLekruZ66v9kh6QdL4MgxVvuWnuhi4DbND1V4b061AE2br4whmjTmI+YbfDXyI2RgqrX8AkHeTkZDlD7MAAAAASUVORK5CYII="

/***/ }),
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(184),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(191),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(180),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(249),
  /* template */
  __webpack_require__(193),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return http; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return clientId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return brandId; });
var host = '';

var env = "production";
console.log('***********************  \u8FD0\u884C\u73AF\u5883\uFF1A ' + env + ' ************************');
if (env == 'production' || env == 'prev') {
    host = '//eapi.my.ciwong.com';
} else {
    host = '//eapi.my.jiaofucloud.cn';
}

var http = host;
var clientId = 100131;
var brandId = 570678343;

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(91);



var HTTP = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* http */] + '/gateway';

// (url, data, method, options)
/* harmony default export */ __webpack_exports__["a"] = ({
	//上传
	upload: function upload(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])('http://wimg2.ciwong.net/avatar/upload', data, 'post', true, true);
	},
	getAreas: function getAreas(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/areas/{code}', data, 'get');
	},
	login: function login(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* http */] + '/oauth/v1/login', data, 'post');
	},
	logout: function logout(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* http */] + '/oauth/v1/logout', data, 'get');
	},
	service: function service(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/user/v2/get_epage_Service', data, 'get');
	},
	// serviceProducts  : (data) => $http(HTTP+'/v5/service/v2/get_service_products_by_id', data, 'get'),
	serviceProducts: function serviceProducts(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/service/v2/get_service_products_by_id_classids', data, 'get');
	},
	catalogues: function catalogues(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/usedpackage/v1/getlatest', data, 'get');
	},
	resources: function resources(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/package/book_resources_v2', data, 'get');
	},
	grads: function grads(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v4/relation/class/get_my_classes', data, 'get');
	},
	publish: function publish(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v6/epaperwork/publishWork', data, 'post');
	},
	// homework  : (data) => $http(HTTP+'/v5/epaperwork/v2/getPublishWorkRecordsForWeiXin', data, 'get'),
	homework: function homework(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v6/epaperwork/v2/getPublishWorkRecords', data, 'get');
	},

	updaterecord: function updaterecord(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/usedpackage/updaterecord', data, 'post');
	},
	finishier: function finishier(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v6/epaperwork/v2/getWorkContenSubmitRecords', data, 'get');
	},
	triggler: function triggler(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/epaperwork/workEventTriggler', data, 'post');
	},
	//获取排行榜
	rankContent: function rankContent(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v6/epaperwork/getEworkContentScoreStatistics', data, 'get');
	},
	rankWork: function rankWork(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v6/epaperwork/v2/getEworkScoreStatistics', data, 'get');
	},
	//获取作业统计
	rankStatistics: function rankStatistics(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v6/epaperwork/v2/workAnswerStatistics', data, 'get');
	},
	//获取单个题目的信息
	getSingleWork: function getSingleWork(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + "/v1/question/GetQuestionByVersions", data, 'get');
	},
	// 获取听说模考试卷
	getExamination: function getExamination(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/tools/listen_speak_examination', data, 'get');
	},
	// 获取在线作答试卷
	getOnlineExamination: function getOnlineExamination(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/h5/v1/package/examinationdata', data, 'get');
	},
	//获取最近书本
	getLast: function getLast(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/user/v2/get_userbook_top', data, 'get');
	},
	//撤回指定作业
	delWork: function delWork(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v6/epaperwork/v3/del_work', data, 'get');
	},
	// 获取答案	@param : doWorkId
	getWorkAnswers: function getWorkAnswers(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v6/epaperwork/v2/getWorkAnswers', data, 'get');
	},
	//获取作业内容详情
	getDoWork: function getDoWork(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v6/epaperwork/getDoWorkInfo', data, 'get');
	},
	//获取用户信息
	getInfo: function getInfo(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/user/get_info', data, 'get');
	},
	//获取课文跟读段落
	getClassText: function getClassText(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/tools/followread_text_paragraph', data, 'get');
	},
	//获取单词
	getWords: function getWords(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/tools/followread_words', data, 'get');
	},
	//获取用户详细信息
	getUserInformation: function getUserInformation(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/user/get_info_base', data, 'get');
	},
	//获取老师布置作业题号
	getTeacherQuerstion: function getTeacherQuerstion(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v6/epaperwork/getDoWorkInfo', data, 'get');
	},
	//获取系统消息接口
	getSystemMessages: function getSystemMessages(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/message/getMsgsByType', data, 'get');
	},
	//获取教育顾问信息接口
	getConsultant: function getConsultant(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/service/v2/get_epage_advisor', data, 'get');
	},
	//获取老师班级详情接口
	getClass: function getClass(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v4/relation/class/get_my_classes', data, 'get');
	},
	//获取老师详细信息学校ID接口:
	getDetailedInf: function getDetailedInf(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/user/getUserInfo', data, 'get');
	},

	//修改老师头像
	getAvatar: function getAvatar(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/user/update_avatar', data, 'get');
	},
	//修改密码
	getPassWord: function getPassWord(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/user/new/updatePwd', data, 'get');
	},
	//发送手机验证码:
	getsendVerifyCode: function getsendVerifyCode(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/user/sendVerifyCode', data, 'get');
	},
	//验证手机验证码:
	getcheckVerifyCode: function getcheckVerifyCode(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/h5/v5/user/checkVerifyCode', data, 'get');
	},
	//修改/绑定手机号
	getMobile: function getMobile(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/user/bindMobile', data, 'get');
	},
	//获取班级成员列表
	getClassStudent: function getClassStudent(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/relation/getclassmembers', data, 'get');
	},
	//删除本班学生
	deleteStudent: function deleteStudent(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v4/relation/class/kick_out_class', data, 'get');
	},
	//获取班级所有服务开通情况
	getAllservice: function getAllservice(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/user/v2/get_service_state2', data, 'get');
	},
	//查询学校列表
	getSchool: function getSchool(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v4/relation/school/search', data, 'get');
	},
	//修改班级信息
	modifyClassInformation: function modifyClassInformation(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/class/update_classInfo_byId', data, 'get');
	},
	//创建班级接口
	createClass: function createClass(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v4/relation/class/create', data, 'post', false, true);
	},
	//统计作业次数
	getHomeworkStatistics: function getHomeworkStatistics(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v6/epaperwork/v2/getEworkRecordsStatistics', data, 'get');
	},
	//设置已读消息
	setRead: function setRead(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/message/setRead', data, 'get');
	},
	//修改性别
	modifySex: function modifySex(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/user/update', data, 'post');
	},
	//未读消息数量
	unreadMessage: function unreadMessage(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/message/getNoReadMsgCountByType', data, 'get');
	},
	//校讯通
	getSchoolMsg: function getSchoolMsg(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/h5/v5/message/agentEventTriggler', data, 'post');
	},

	modifyPwd: function modifyPwd(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/user/setPassword', data, 'get');
	},
	//置顶
	setBookTop: function setBookTop(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/user/v2/set_userbook_top', data, 'get');
	},
	//分享
	toShare: function toShare(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/comm/url/longToShort', data, 'post');
	},
	searchStudent: function searchStudent(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/user/getUserByMobile', data, 'get');
	},
	//添加单个学生进入班级
	addOneStudent: function addOneStudent(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v4/relation/class/apply', data, 'get');
	},
	//批量创建学生账号
	createStudent: function createStudent(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/relation/createAndAddStudentMembers', data, 'post');
	},
	//一键催交
	urgeWorks: function urgeWorks(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/epaperwork/workEventTriggler', data, 'post');
	},
	//在线批改作业
	correctWork: function correctWork(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v6/epaperwork/saveCorrectAnswer', data, 'post');
	},
	//听说批改作业
	correctListenWork: function correctListenWork(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/epaperwork/examination/correct_listenspeak', data, 'post');
	},
	//获取试卷http://192.168.2.164:8069/BooksAuthor/GetList?userID=155014&keyWord=&periodId=0&SubjectID=0&pageIndex=1&pageSize=20
	getPaper: function getPaper(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/Package/GetList', data, 'get');
	},
	//ExaminationID
	delPaper: function delPaper(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/Package/DeleteExamination', data, 'post');
	},
	//http://100.114.31.171:8895/message/agentEventTriggler
	setClassMsg: function setClassMsg(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/message/agentEventTriggler', data, 'post');
	},
	//http://192.168.1.48:8895/message/getSendMessages
	getClassMsg: function getClassMsg(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/message/getSendMessages', data, 'get');
	},
	//注册
	signup: function signup(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/h5/v5/user/signin', data, 'get');
	},
	// getAllCount: (data) => $http(HTTP+ '/v2/package/resource_statistics_web', data, 'get'),
	getAllCount: function getAllCount(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/package/resource_statistics_web', data, 'get');
	},
	//预览筛选
	filterListen: function filterListen(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v1/Package/resource_data_web', data, 'get');
	},
	// 获取班级交集服务
	getClassService: function getClassService(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v5/user/v2/get_epage_Service_classids', data, 'get');
	},
	//最近布置过
	getRecentPublishBokk: function getRecentPublishBokk(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */])(HTTP + '/v6/epaperwork/getpublishbook', data, 'get');
	}
});

/***/ }),
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(195),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 100 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 101 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 102 */,
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var routerObj = [{
    path: 'selectOnlinePaper/:versionId/:userId',
    name: 'selectOnlinePaper',
    title: '在线作答预览',
    component: __webpack_require__(174)
}, {
    path: 'checkOnlinePaper',
    name: 'checkOnlinePaper',
    title: '在线作答详情',
    component: __webpack_require__(170)
}];

/* harmony default export */ __webpack_exports__["a"] = ([{
    path: '/api',
    name: 'api',
    component: __webpack_require__(176),
    children: routerObj
}]);

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
		setHomework: '书籍列表',
		login: '登录',
		publishHomeWork: '书本目录',
		home: '作业',
		personMsg: '个人中心',
		systemMessages: '系统消息',
		readWords: '选择单词',
		selectListenSpeak: '选择听说模考大题',
		selectText: '选择段落',
		class: '班级管理',
		checkOnlinePaper: '在线作答详情',
		selectOnlinePaper: '在线作答预览',
		checkTSMK: '听说模考详情',
		ranks: '单个作业排名',
		rankWork: '总排名',
		register: '注册',
		ForgotPwd: '忘记密码',
		schoolMsg: '校讯通',
		managePaper: '管理试卷',
		publishBooks: '布置作业',
		selectObject: '布置对象',
		watchSinglePaper: '错题统计',
		watchStudc: '查看单词详情',
		watchStukw: '查看课文详情'
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_crumb__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_works__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_user__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_subject__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_toast__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_catalog__ = __webpack_require__(262);












__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_4__getters__["a" /* default */],
    modules: {
        crumb: __WEBPACK_IMPORTED_MODULE_5__modules_crumb__["a" /* default */],
        works: __WEBPACK_IMPORTED_MODULE_6__modules_works__["a" /* default */],
        user: __WEBPACK_IMPORTED_MODULE_7__modules_user__["a" /* default */],
        subject: __WEBPACK_IMPORTED_MODULE_8__modules_subject__["a" /* default */],
        toast: __WEBPACK_IMPORTED_MODULE_9__modules_toast__["a" /* default */],
        catalog: __WEBPACK_IMPORTED_MODULE_10__modules_catalog__["a" /* default */]
    },
    plugins: __WEBPACK_IMPORTED_MODULE_3__plugins__["a" /* default */]
}));

/***/ }),
/* 106 */
/***/ (function(module, exports) {

var Toast = {};
Toast.install = function (Vue, options) {
    var opt = {
        defaultType: 'right', // 默认显示颜色
        duration: '3000' // 持续时间
    };
    for (var property in options) {
        opt[property] = options[property]; // 使用 options 的配置
    }
    Vue.prototype.$toast = function (tips, type) {
        if (type) {
            opt.defaultType = type; // 如果有传type，位置则设为该type
        }
        if (document.getElementsByClassName('vue-toast').length) {
            // 如果toast还在，则不再执行
            return;
        }
        var template = '<div class="vue-toast toast-' + opt.defaultType + '">';
        var imgUrl = void 0;
        if (opt.defaultType == 'right') {
            imgUrl = './static/toast-right.png';
        } else {
            imgUrl = './static/toast-error.png';
        }
        template += "<img src=" + imgUrl + " /><p>" + tips + '</p></div>';

        var toastTpl = Vue.extend({
            // template: '<div class="vue-toast toast-'+opt.defaultType+'"><p>' + tips + '</p></div>'
            template: template

        });
        var tpl = new toastTpl().$mount().$el;
        document.body.appendChild(tpl);
        setTimeout(function () {
            document.body.removeChild(tpl);
        }, opt.duration);
    };
};
module.exports = Toast;

/***/ }),
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loading.4b6fc83.gif";

/***/ }),
/* 127 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkU3ODZGMjNBODNGMzExRTdBMEFFOEU0MTk4MjczMzhCIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkU3ODZGMjNCODNGMzExRTdBMEFFOEU0MTk4MjczMzhCIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RTc4NkYyMzg4M0YzMTFFN0EwQUU4RTQxOTgyNzMzOEIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RTc4NkYyMzk4M0YzMTFFN0EwQUU4RTQxOTgyNzMzOEIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6JYudyAAALm0lEQVR42txdaWxcVxU+XuJtvI13J3YcL7HjeIsdJ81aSlGBRCxq+YFAKgQhFhVECAikil+IHyAVRIUEqCDRoiKWHyWCqoloEU3StHGcxI7jZbzGW2KP930Zx2Nzvuc3896Mx/bM+N43Yx/py5uxx/e+9825557tvYSsrq5SoOTKlauJfKhklDMOMg4w0hnJDDMjRP3oCmOCMcawMroZ7YwHjPrz58/NBuoaQowkkAmL5MOzjHOMjzNKdCT5KyC3gfE+4yrjOhP6ZNcQyKSFqKRdYHyOES/5mqCp/2S8zkR+uGMJZOJMfPga4yKjIEArrJnxKuNNJtO2Iwhk4qL58BLjZdWWBYMMMH7G+BMTuRS0BDJ5X+TDK4xsCk7pYFxiEt8JKgKZOOyerzE+STtDYCO/w0RaA04gk/ciH37LiKOdJXCJvs4k/isgBDJxUXz4nbpR7GT5NePHTOSyYQQyeXB232Yco90h8CFfYBInpRPI5MEl+S8jh3aXWGDDmcRHvvxRqI/klfHh5i4kD1LMuKYqiHgNVAf+iJFqSIgUGkrhYWHK62W7nVZXVowisovxjLea6BWBTF4mH2oY+2WddVJyEqWlpZHZbKZYk4n27Nnj8vulpSWam5+niYkJGhoaponxcdnL+ZQ3NnFLApm8GD58wKgSfZZh4WGUk5NDBxhRUVE+/e3i4iL19PZSL8O+bJdB4jXGc1vtzuFeDPSaDPL2Ze2j4kOHKCIiwq+/B+GHioooLzeXLJZWevz4sehTfEaNqi75rYGsfd/gwx9EnlX4nnCqKK+g9PQ0l5/jPMZ5eQ4PD9Pk5BTNzc3Skm2JQkJCKCIygky8rJPMSZSamqIsc3cZHLTSg8YHMrQR7s1lnwlk8pDgrGeYRJ1JZFQkPXX8OMXGxjp/tsKbQ19fHz3s7qbFhUWvxomOiaGC/DzKyspSCHbI9PQ03b5dS0+eCE0HwtiWMomDXhOo5vBgA54WdRbYFE6fPkUxMTHOn01MTlJDQwPNz837NWZcXBwdOVKhHDUSZ+hWzS3RmniZCXzBFz/wgkjyoCXVx6pdyOtlrau5VeM3eZCZmRm6+eFHNDCoKUd8fBwdrRJusp9npfqsVxrIH0TGGPWGdFGzFxYWUkFBvuZoPXxIba1tQq+wrLyMsnlJO6StrZ26urpE+4eH3fOJnjTwByLJM8WaKJ/tlUOsVqtw8iBNjU00pvMNDx4sUGylQIEGfHPTJaxWyb4vND5iV8Vh6OG7PWhslOL5YiXV19fT8vKa2xbKkUxRUaHoaX6iZqE21ECk4hNEah+iC4e0WCy0/GSZZAncnrb2duf7zIwMio6OFjlFBuNFjwQys4idvitytv3ZWuQ3OztH1kEryZa+vn5F0x2bV1Z2lugpLm2kgZ/Blyb068pI111YnyGZACQdHj3SopKM9HTRUxSzsp31RKDQzDKWjn75DAwOGJaXGtS5NfAR3RMTAuSCC4HMKOzep0TOkGhOdL6en59X7JNRAv9QH43EJwiv5T+vdlk4NfA8I0LkDKYYk87+Gd+6Mjs35/FcBIlZTTY4CTwnegb9srHZbIYTqJ9TwhKGfFpP4CdEjx4eHuZ8bbfbDSdwdWVVdy7hMqZ4ViGQ1zLqG3tFj/5kWfP3wuRcwObxd6iWpVleluJ7liLshQZWS3Fql7RNI9rHbLMQL0A3p21JigkBd5X4p0zG6Posiz7dZIj2sQOtzznOzkjbxMpBYKGMkccntMA+MjJSdGC/uQuVmEhhakUPCdup6WlZUx0EgQdkxaVzOlciK2ufYQRm7tUCKpQHJJZEc0NFh2+uEYFVFxdnK7Ve2YJKX9Y+7csaGJAaAWXgiqQVyvv7+8mRsMUyRvlStuTn5TvdFuy+kkPIZBBokjX6wsKCS7pdSXKKTS+5SGxcLOXl5Trfo2wgM30Gcyt9TbW2tjodaWhGVVWllKWMpVtVWaUkUh2RSGdnp+zLk2+UbIs2am3TUvgJCQl8oZUu5cjtO82hVH30KLsu2mJqamqW1bGwzhmUfqNIb0+vy4aCovrx48eExKgoup88cYKSk7V+9p6eHhoaGjJiw18AgdNGzHS/oYHGxyc068sXfPbsGUpN838Py8jIoKfPnmW/T6tCoPGopcVilMe0gO1qlATWQTYO7lfodm0tHT1aRWmpa6Shv+VYdTWNjY1RZ1cXjY2OeTUWSC/Iz1/X4mFlrauvv29k0DMMArG28o3JkKzQ3Tt319WJoY0Aahkjo6NKC9sch4IrK2s2DFEFcnogDL0xcIncBa0hKJcafO/fAAjsYZw2ctb29nYaGRmh0tISlzgZGoniuL5AvpUg+9zU3CK7X3AjeQQbaAnEzNCUGQGZ6smpKVnpKm+kBRrYbOSMCPSLDxeTOTFRyHgOjYUdbbG00sz0tJGX0wwCa42YCX2BpaWltDdzfeiNjAnaMsbHxpXMCZIQNtsihYWGsY+1qmhrTHSMUqjHF5DC9jI+3rVQpOzqZ04r4WNzSwut2KX3VMNA1ynNRVeuXH2IzIKsmcxJSVR5pGJdGy9a0dCi+3jgsc8XjF7D7OxsJUnhPu78/ALV1dfR9JRUbbxz/vy5445c+3VZBO7fv59KSg67RB64QIvFsi1nFxFOZ0cndXU9ZCKzlHZfRxIhJiaaTp08qfieErshrjkiEcjbUpJlubnKTqsnD+7GjQ9uCIsU4Br19fbRtWvXFT9QC1JDlZBRQmuHQ97RE/guvlSRoytN5MWHNINht9Pde/eolQ29DPuEGkzdvTolCtH7gmVsd9Pc+rEFCHymm04C1Yc2CNNC3PNRXlbmcnG3ampomMMs2YI4uK6uXtmYlEQDaz80UXBd5h/MmV2vgZDXRYyM2xYqjxxxLltoXu2dO7INuovAPNy/3+DURGU5V1UqKS9B8oY+G+OQ/zC23UJVUlLiEmrdY20wkjxnXGy1UquuExa3SRQVCqmfPWDtq11HoKqSr25n5OSUZMrMzHC+xw45yiFboKSbN6whndnAXVEClvIv9W/cE6p/ZEz5O3JRYZHzNZzh9o4OCrQ0NjU6Qz2YlcLtaWE/4+8bEqhuJj/3Z+SUlBSXvFwzdkPj7rDceHe2LVFHh5baRzJ3G1r4U/eH+nhK6f+G1h4T4pPk6CpuqMUGcumu25k52tF3a+X4Vx1sZfzZ/YfrCGSGF/jwI19GRmo+TZdZ7u7ppmASxdnu73e+h532oyZz0dOdmx6LSvzBv/LhPW9HRie+44TQGWq1DlGwSb+OQHzh5iSzL3/+N+bkXU+/2Kwq9y3GjFf2LzXF+RoZ5WCwfe6CGxmRvHBIaorXtRhs4xc3+uWGBDLjWIcveTNDQry2eYwEke1zl9GxUedrH/qmLzAXIz4TqJL4l60iFNRkTSat8yoQTrO3MjWleWhxuva3TeQV5uDqZh/wprD+bcatjX4ZxVGHw/4hdApEQ7m3ou8T9FSYchMQ9/JWH9qSQPXuRNwr6/HWR30yExtIIJ+IuaUdXNRu6MaXvklsjBv6vuRIGGy6An147AkSrnj4hEujH1L1iDMhSFOhShbMkqBz9mFuPFw/FOXkZnbPLwJVEhEH/c+dxF0kPj0zxlsbqF/OuBXy9EbLeYdLo6p58h79pJLYy4cTjBu7iDyk5894u2y3RaBKIhyq5xi/3wXk/YLxeb4mv/wvEQ9g/AKtpcHMO4w4lOu+wsS9t51Btt1gySfwFq3da3J5B5H3JqN8u+QJ0UA3bcSjQfBEyPwgJa6J8T0m7n1RAwpt8eUTQ2XvkBpDDwYRcYjrv8qoEEmecA1000bcf/xlxg8ZpQEi7g7jV4y3/H1GasAIdCPzKVUD8JzpJMnTIRmJusUbTJr0dlWj/zMCBJ+naO0BFx+jtcfqbbfT3KZqGvp7/s24y8QZlpAMCfB/h4G7bioYh9Vlvk8FejFgApBzAhnzKlHQLtRrUL9uobXexgbRj3f3Rf4vwAAutGi1QjPsewAAAABJRU5ErkJggg=="

/***/ }),
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(238),
  /* template */
  __webpack_require__(189),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(240),
  /* template */
  __webpack_require__(192),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(241),
  /* template */
  __webpack_require__(183),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(196),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(190),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(255),
  /* template */
  __webpack_require__(187),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(256),
  /* template */
  __webpack_require__(188),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qStem"
  }, [_c('p', {
    staticClass: "qDescript",
    domProps: {
      "innerHTML": _vm._s(_vm.question.question_description)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-20"
  }, [(_vm.question.sid > -1 && _vm.moduleId != 15) ? _c('span', {
    staticClass: "queNum"
  }, [_vm._v(" " + _vm._s(_vm.question.sid + 1) + ". ")]) : _vm._e(), _vm._v(" "), (_vm.question.question_ref_sorce) ? _c('b', [_vm._v("(" + _vm._s(_vm.question.question_ref_sorce || 0) + "分, " + _vm._s(_vm.question.difficultyDegree) + "难度)")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "qStemC"
  }, [_c('div', {
    staticClass: "qsamllStem",
    domProps: {
      "innerHTML": _vm._s(_vm.fillFormatHtml(_vm.question.stem))
    }
  }), _vm._v(" "), _c('attachments', {
    attrs: {
      "attachments": _vm.question.attachments,
      "playerObj": _vm.playerObj,
      "id": _vm.question.id
    },
    on: {
      "playedObj": _vm.playedObj
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_vm._l((_vm.question.options), function(option, $index) {
    return (_vm.isShowAnswer) ? _c('div', [_c('div', {
      staticClass: "u-question-item"
    }, [_c('span', {
      staticClass: "color-999999"
    }, [_vm._v("学生答案：")]), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.setFillingAnswer(_vm.question.userAnswer, $index))
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "fr u-question-r"
    }, [_c('div', {
      staticClass: "assessIconBox f-error_txt",
      domProps: {
        "innerHTML": _vm._s(_vm.setAssessIcon(_vm.question, $index))
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.setNewAns(_vm.question, $index)
        }
      }
    }), _vm._v(" "), _c('span', [_vm._v("（"), _c('span', {
      staticClass: "col-red",
      domProps: {
        "innerHTML": _vm._s(_vm.setAssessFilling(_vm.question, $index))
      }
    }), _vm._v(" / " + _vm._s(parseFloat((_vm.question.question_ref_sorce / _vm.question.options.length).toFixed(1)) || 0) + "分）")]), _vm._v(" "), (_vm.handle == $index) ? _c('div', {
      staticClass: "handleScore clearfix"
    }, [_c('span', {
      staticClass: "correcting",
      class: {
        half_right: _vm.halfRight, half_right_hover: !_vm.halfRight
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.handleHr(_vm.question, $index)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "correcting",
      class: {
        C_right: _vm.Cright, C_right_hover: !_vm.Cright
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.handleCr(_vm.question, $index)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "correcting",
      class: {
        C_error: _vm.C_error, C_error_hover: !_vm.C_error
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.handleCe(_vm.question, $index)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.scoreVal),
        expression: "scoreVal"
      }],
      staticClass: "scoreNow",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (_vm.scoreVal)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        },
        "change": function($event) {
          _vm.checkPrice(_vm.question, $index, _vm.scoreVal)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.scoreVal = $event.target.value
        }
      }
    }), _vm._v("\n                            分\n                            "), _c('input', {
      staticClass: "scoreSure",
      attrs: {
        "type": "button",
        "value": "确定"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.sentNewSocre(_vm.question, $index, _vm.scoreVal)
        }
      }
    })]) : _vm._e()])])]) : _vm._e()
  }), _vm._v(" "), (_vm.moduleId == 15) ? _c('listenTabTopic', {
    attrs: {
      "infoAnswer": _vm.question.options,
      "listenTextModule": _vm.question.textModule[0],
      "qtype": 3
    }
  }) : _c('tabTopic', {
    attrs: {
      "isObject": false,
      "infoAnswer": _vm.question.options,
      "knowledgePoints": _vm.question.knowledge_points,
      "skillPoints": _vm.question.skill_points,
      "explains": _vm.question.explains,
      "tags": _vm.question.tags,
      "qtype": 3
    }
  })], 2)], 1)])
},staticRenderFns: []}

/***/ }),
/* 178 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab_Topic"
  }, [_c('ul', {
    staticClass: "clearfix tabBt"
  }, [_c('li', {
    class: {
      topic_Active: _vm.topicActive == 1
    },
    on: {
      "click": function($event) {
        _vm.tabListen(1)
      }
    }
  }, [_vm._v("参考答案")]), _vm._v(" "), (_vm.listenTextModule && _vm.listenTextModule.length > 0 && _vm.listenTextModule[0].questionStem) ? _c('li', {
    class: {
      topic_Active: _vm.topicActive == 2
    },
    on: {
      "click": function($event) {
        _vm.tabListen(2)
      }
    }
  }, [_vm._v("听力原文")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "Topic_bg"
  }, [(_vm.topicActive == 1) ? _c('div', [_vm._l((_vm.infoAnswer), function(val, answerindex) {
    return (_vm.qtype == 1) ? _c('span', [_vm._v(_vm._s(_vm._f("fromCharCode")(val.index)))]) : _vm._e()
  }), _vm._v(" "), (_vm.qtype == 2) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.setRefAnswer(_vm.question.options, _vm.question.ref_info))
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.infoAnswer), function(val, stemIndex) {
    return (_vm.qtype == 3) ? _c('p', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(val.stem)
      }
    })]) : _vm._e()
  }), _vm._v(" "), (_vm.qtype == 6) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.infoAnswer.solving_idea)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.qtype == 7) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.infoAnswer)
    }
  }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.topicActive == 2 && _vm.listenTextModule) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.listenTextModule[0].questionStem)
    }
  }) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 179 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qStem"
  }, [_c('p', {
    staticClass: "qDescript",
    domProps: {
      "innerHTML": _vm._s(_vm.question.question_description)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-20"
  }, [(_vm.question.sid > -1 && _vm.moduleId != 15) ? _c('span', {
    staticClass: "queNum"
  }, [_vm._v(" " + _vm._s(_vm.question.sid + 1) + ". ")]) : _vm._e(), _vm._v(" "), (_vm.question.question_ref_sorce) ? _c('span', [_vm._v("(" + _vm._s(_vm.question.question_ref_sorce || 0) + "分, " + _vm._s(_vm.question.difficultyDegree) + "难度)")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "qStemC"
  }, [_c('div', {
    staticClass: "qsmallStem",
    domProps: {
      "innerHTML": _vm._s(_vm.question.stem)
    }
  }), _vm._v(" "), _c('attachments', {
    attrs: {
      "attachments": _vm.question.attachments,
      "playerObj": _vm.playerObj,
      "id": _vm.id
    },
    on: {
      "playedObj": _vm.playedObj
    }
  }), _vm._v(" "), (_vm.moduleId == 124 && !_vm.underlineF) ? _c('div', [_c('div', {
    staticClass: "underline"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "underline"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "underline"
  }, [_vm._v(" ")])]) : _vm._e(), _vm._v(" "), (_vm.isShowAnswer) ? _c('div', [_c('div', {
    staticClass: "u-question-item"
  }, [_c('span', {
    staticClass: "color-999999 inline-b"
  }, [_vm._v("学生答案：")]), _vm._v(" "), (_vm.moduleId == 15 && _vm.question.userAnswer && _vm.question.userAnswer.answers && _vm.question.userAnswer.answers[0] && _vm.question.userAnswer.answers[0].content) ? _c('span', [_c('theAudio', {
    attrs: {
      "src": _vm.question.userAnswer.answers[0].content,
      "id": _vm.id + 10001,
      "playerObj": _vm.playerObj
    },
    on: {
      "playedObj": _vm.playedObj
    }
  })], 1) : (_vm.moduleId == 124) ? _c('div', {
    staticClass: "inline-b"
  }, [(_vm.padShow) ? _c('span', {
    staticClass: "editImg",
    attrs: {
      "onClick": "brigeCanvas(this)"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.matchUrl(_vm.question.userAnswer && _vm.question.userAnswer.answers && _vm.question.userAnswer.answers[0] && _vm.question.userAnswer.answers[0].content))
    }
  }) : _c('div', {
    staticClass: "fl",
    domProps: {
      "innerHTML": _vm._s(_vm.matchUrl(_vm.question.userAnswer && _vm.question.userAnswer.answers && _vm.question.userAnswer.answers[0] && _vm.question.userAnswer.answers[0].content))
    },
    on: {
      "click": function($event) {
        _vm.imgFun(_vm.question)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.bigImgShow && _vm.imgFlag) ? _c('bigImgShow', {
    attrs: {
      "imgSrc": _vm.imgUrl
    },
    on: {
      "imgBigShow": _vm.imgBigShow
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "u-shortAnswer"
  }, [_c('div', {
    staticClass: "assessIconBox f-error_txt",
    domProps: {
      "innerHTML": _vm._s(_vm.setAssessIcon(_vm.question.userAnswer))
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.setNewAns(_vm.question)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("（"), _c('span', {
    staticClass: "col-red",
    domProps: {
      "innerHTML": _vm._s(_vm.setAssess(_vm.question.userAnswer))
    }
  }), _vm._v(" / " + _vm._s(parseFloat(_vm.question.question_ref_sorce)) + "分）")]), _vm._v(" "), (_vm.handle) ? _c('div', {
    staticClass: "handleScore clearfix"
  }, [_c('span', {
    staticClass: "correcting",
    class: {
      half_right: _vm.halfRight, half_right_hover: !_vm.halfRight
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.handleHr(_vm.question)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "correcting",
    class: {
      C_right: _vm.Cright, C_right_hover: !_vm.Cright
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.handleCr(_vm.question)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "correcting",
    class: {
      C_error: _vm.C_error, C_error_hover: !_vm.C_error
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.handleCe(_vm.question)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scoreVal),
      expression: "scoreVal"
    }],
    staticClass: "scoreNow",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.scoreVal)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      },
      "change": function($event) {
        _vm.checkPrice(_vm.question, _vm.scoreVal)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.scoreVal = $event.target.value
      }
    }
  }), _vm._v("\n                        分\n                        "), _c('input', {
    staticClass: "scoreSure",
    attrs: {
      "type": "button",
      "value": "确定"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.sentNewSocre(_vm.question, _vm.question.question_ref_sorce / _vm.question.options.length, _vm.scoreVal)
      }
    }
  })]) : _vm._e()])], 1)]) : _vm._e(), _vm._v(" "), (_vm.moduleId == 15) ? _c('listenTabTopic', {
    attrs: {
      "infoAnswer": _vm.question.ref_info,
      "listenTextModule": _vm.question.textModule,
      "qtype": 6
    }
  }) : _vm._e(), _vm._v(" "), (_vm.moduleId == 124) ? _c('tabTopic', {
    attrs: {
      "isObject": false,
      "infoAnswer": _vm.question.ref_info && _vm.question.ref_info.answers[0],
      "knowledgePoints": _vm.question.knowledge_points,
      "skillPoints": _vm.question.skill_points,
      "explains": _vm.question.explains,
      "tags": _vm.question.tags,
      "qtype": 6
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qStem"
  }, [_c('p', {
    staticClass: "qDescript",
    domProps: {
      "innerHTML": _vm._s(_vm.question.question_description)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-20"
  }, [(_vm.question.sid > -1 && _vm.moduleId != 15) ? _c('span', {
    staticClass: "queNum"
  }, [_vm._v(" " + _vm._s(_vm.question.sid + 1) + ".")]) : _vm._e(), _vm._v(" "), (_vm.question.question_ref_sorce) ? _c('span', [_vm._v("(" + _vm._s(_vm.question.question_ref_sorce || 0) + "分, " + _vm._s(_vm.question.difficultyDegree) + "难度)")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "qStemC"
  }, [_c('div', {
    staticClass: "qsamllStem",
    domProps: {
      "innerHTML": _vm._s(_vm.question.stem)
    }
  }), _vm._v(" "), _c('attachments', {
    attrs: {
      "attachments": _vm.question.attachments,
      "playerObj": _vm.playerObj,
      "id": _vm.question.id
    },
    on: {
      "playedObj": _vm.playedObj
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.isShowAnswer) ? _c('div', [_c('div', {
    staticClass: "u-question-item"
  }, [_c('span', {
    staticClass: "color-999999"
  }, [_vm._v("学生答案：")]), _vm._v(" "), (_vm.question.userAnswer) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.setAnswers(_vm.question.userAnswer.answers[0].content))
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [_c('div', {
    staticClass: "assessIconBox",
    domProps: {
      "innerHTML": _vm._s(_vm.setAssessIcon(_vm.question.userAnswer))
    }
  }), _vm._v(" "), _c('span', [_vm._v("（"), _c('span', {
    staticClass: "col-red",
    domProps: {
      "innerHTML": _vm._s(_vm.setAssess(_vm.question.userAnswer))
    }
  }), _vm._v(" / " + _vm._s(parseFloat(_vm.question.question_ref_sorce)) + "分）")])])])]) : _vm._e(), _vm._v(" "), _c('tabTopic', {
    attrs: {
      "isObject": false,
      "infoAnswer": _vm.question.ref_info.answers,
      "skillPoints": _vm.question.skill_points,
      "knowledgePoints": _vm.question.knowledge_points,
      "explains": _vm.question.explains,
      "qtype": 8,
      "tags": _vm.question.tags
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "option-box clearfix"
  }, [_c('div', {
    staticClass: "option-item"
  }, [_c('span', {
    staticClass: "checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  })]), _c('span', {
    staticClass: "m-l10"
  }, [_vm._v("正确")])]), _vm._v(" "), _c('div', {
    staticClass: "option-item"
  }, [_c('span', {
    staticClass: "checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  })]), _c('span', {
    staticClass: "m-l10"
  }, [_vm._v("错误")])])])
}]}

/***/ }),
/* 181 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "inline-block"
  }, [_c('div', {
    staticClass: "button",
    class: _vm.myIsPlay ? 'play' : 'pause',
    attrs: {
      "id": _vm.id
    },
    on: {
      "click": _vm.player
    }
  }, [_c('audio', {
    attrs: {
      "src": _vm.src,
      "preload": "auto"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 182 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qStem"
  }, [_c('p', {
    staticClass: "qDescript",
    domProps: {
      "innerHTML": _vm._s(_vm.question.question_description)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-20"
  }, [(_vm.question.sid > -1 && _vm.moduleId != 15) ? _c('span', {
    staticClass: "queNum"
  }, [_vm._v(" " + _vm._s(_vm.question.sid + 1) + ". ")]) : _vm._e(), _vm._v(" "), (_vm.question.question_ref_sorce) ? _c('span', [_vm._v("(" + _vm._s(_vm.question.question_ref_sorce || 0) + "分, " + _vm._s(_vm.question.difficultyDegree) + "难度)")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "qStemC"
  }, [_c('div', {
    staticClass: "qsamllStem",
    domProps: {
      "innerHTML": _vm._s(_vm.question.stem)
    }
  }), _vm._v(" "), _c('attachments', {
    attrs: {
      "attachments": _vm.question.attachments,
      "playerObj": _vm.playerObj,
      "id": _vm.question.id
    },
    on: {
      "playedObj": _vm.playedObj
    }
  }), _vm._v(" "), (_vm.isShowAnswer) ? _c('div', [_c('div', {
    staticClass: "u-question-item"
  }, [_c('span', {
    staticClass: "color-999999"
  }, [_vm._v("学生答案：")]), _vm._v(" "), _c('span', [_c('theAudio', {
    attrs: {
      "src": _vm.question.userAnswer && _vm.question.userAnswer.answers[0].content,
      "id": _vm.id + 1111111,
      "playerObj": _vm.playerObj
    },
    on: {
      "playedObj": _vm.playedObj
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "u-shortAnswer"
  }, [_c('div', {
    staticClass: "assessIconBox",
    domProps: {
      "innerHTML": _vm._s(_vm.setAssessIcon(_vm.question.userAnswer))
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.setNewAns(_vm.question)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("（"), _c('span', {
    staticClass: "col-red",
    domProps: {
      "innerHTML": _vm._s(_vm.setAssess(_vm.question.userAnswer))
    }
  }), _vm._v("/" + _vm._s(parseFloat(_vm.question.question_ref_sorce)) + "分）")]), _vm._v(" "), (_vm.handle) ? _c('div', {
    staticClass: "handleScore clearfix"
  }, [_c('span', {
    staticClass: "correcting",
    class: {
      half_right: _vm.halfRight, half_right_hover: !_vm.halfRight
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.handleHr(_vm.question)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "correcting",
    class: {
      C_right: _vm.Cright, C_right_hover: !_vm.Cright
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.handleCr(_vm.question)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "correcting",
    class: {
      C_error: _vm.C_error, C_error_hover: !_vm.C_error
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.handleCe(_vm.question)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scoreVal),
      expression: "scoreVal"
    }],
    staticClass: "scoreNow",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.scoreVal)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      },
      "change": function($event) {
        _vm.checkPrice(_vm.question, _vm.scoreVal)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.scoreVal = $event.target.value
      }
    }
  }), _vm._v("\n                        分\n                        "), _c('input', {
    staticClass: "scoreSure",
    attrs: {
      "type": "button",
      "value": "确定"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.sentNewSocre(_vm.question, _vm.question.question_ref_sorce / _vm.question.options.length, _vm.scoreVal)
      }
    }
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.moduleId == 15) ? _c('listenTabTopic', {
    attrs: {
      "infoAnswer": _vm.question.ref_info.answers[0],
      "listenTextModule": false,
      "qtype": 7
    }
  }) : _c('tabTopic', {
    attrs: {
      "isObject": false,
      "infoAnswer": _vm.question.options,
      "knowledgePoints": _vm.question.knowledge_points,
      "skillPoints": _vm.question.skill_points,
      "explains": _vm.question.explains,
      "tags": _vm.question.tags,
      "qtype": 3
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alertBigImg"
  }, [_c('div', {
    staticClass: "imgMask",
    on: {
      "click": _vm.imgFun
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img_Pos",
    attrs: {
      "src": _vm.imgSrc
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 184 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qStem"
  }, [_c('p', {
    staticClass: "qDescript",
    domProps: {
      "innerHTML": _vm._s(_vm.question.question_description)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-20"
  }, [(_vm.question.sid > -1 && _vm.moduleId != 15) ? _c('span', {
    staticClass: "queNum"
  }, [_vm._v(_vm._s(_vm.question.sid + 1) + ". ")]) : _vm._e(), _vm._v(" "), (_vm.question.question_ref_sorce) ? _c('span', [_vm._v("(" + _vm._s(_vm.question.question_ref_sorce || 0) + "分, " + _vm._s(_vm.question.difficultyDegree) + "难度)")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "qStemC"
  }, [_c('div', {
    staticClass: "qsamllStem",
    domProps: {
      "innerHTML": _vm._s(_vm.fillFormatHtml(_vm.question.stem))
    }
  }), _vm._v(" "), _c('attachments', {
    attrs: {
      "attachments": _vm.question.attachments,
      "playerObj": _vm.playerObj,
      "id": _vm.question.id
    },
    on: {
      "playedObj": _vm.playedObj
    }
  }), _vm._v(" "), (_vm.moduleId == 124) ? _c('tabTopic', {
    attrs: {
      "infoAnswer": _vm.question.ref_info && _vm.question.ref_info.answers[0],
      "knowledgePoints": _vm.question.knowledge_points,
      "skillPoints": _vm.question.skill_points,
      "explains": _vm.question.explains,
      "tags": _vm.question.tags,
      "qtype": 4,
      "isObject": true
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.question.children), function(question, index) {
    return _c('div', {
      staticClass: "m-t20"
    }, [(question.qtype == 1) ? _c('singleChoice', {
      attrs: {
        "question": question,
        "playerObj": _vm.playerObj,
        "moduleId": _vm.moduleId,
        "parentqtype": question.qtype,
        "isShowAnswer": _vm.isShowAnswer
      },
      on: {
        "playedObj": _vm.playedObj
      }
    }) : (question.qtype == 3) ? _c('filling', {
      attrs: {
        "question": question,
        "playerObj": _vm.playerObj,
        "moduleId": _vm.moduleId,
        "parentqtype": question.qtype,
        "isShowAnswer": _vm.isShowAnswer
      },
      on: {
        "playedObj": _vm.playedObj,
        "correctScore": _vm.correctScore
      }
    }) : (question.qtype == 6) ? _c('shortanswer', {
      attrs: {
        "question": question,
        "underlineF": true,
        "id": question.id + index,
        "playerObj": _vm.playerObj,
        "moduleId": _vm.moduleId,
        "parentqtype": question.qtype,
        "isShowAnswer": _vm.isShowAnswer
      },
      on: {
        "playedObj": _vm.playedObj
      }
    }) : (question.qtype == 7) ? _c('imitation', {
      attrs: {
        "question": question,
        "playerObj": _vm.playerObj,
        "moduleId": _vm.moduleId,
        "parentqtype": question.qtype,
        "isShowAnswer": _vm.isShowAnswer
      },
      on: {
        "playedObj": _vm.playedObj
      }
    }) : _vm._e()], 1)
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.emptyFlag) ? _c('div', {
    staticClass: "tab_Topic"
  }, [_c('ul', {
    staticClass: "clearfix tabBt_e",
    class: {
      tabBt: false
    }
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.infoAnswer),
      expression: "infoAnswer"
    }],
    class: {
      topic_Active: _vm.topicActive == 1
    },
    on: {
      "click": function($event) {
        _vm.topicAct(1)
      }
    }
  }, [_vm._v("参考答案")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.explains[0]),
      expression: "explains[0]"
    }],
    class: {
      topic_Active: _vm.topicActive == 3
    },
    on: {
      "click": function($event) {
        _vm.topicAct(3)
      }
    }
  }, [(!_vm.isObject) ? _c('span', [_vm._v("试题解析")]) : _c('span', [_vm._v("综合讲解")])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.knowledgePoints.length > 0),
      expression: "knowledgePoints.length>0"
    }],
    class: {
      topic_Active: _vm.topicActive == 2
    },
    on: {
      "click": function($event) {
        _vm.topicAct(2)
      }
    }
  }, [_vm._v("考点")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.skillPoints.length > 0),
      expression: "skillPoints.length>0"
    }],
    class: {
      topic_Active: _vm.topicActive == 5
    },
    on: {
      "click": function($event) {
        _vm.topicAct(5)
      }
    }
  }, [_vm._v("能力点")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tags),
      expression: "tags"
    }],
    class: {
      topic_Active: _vm.topicActive == 4
    },
    on: {
      "click": function($event) {
        _vm.topicAct(4)
      }
    }
  }, [_vm._v("试题标签")])]), _vm._v(" "), (_vm.topicActive == 1 && _vm.infoAnswer) ? _c('div', {
    staticClass: "Topic_bg"
  }, [_vm._l((_vm.infoAnswer), function(val, answerindex) {
    return (_vm.qtype == 1) ? _c('span', [_vm._v(_vm._s(_vm._f("fromCharCode")(val.index)))]) : _vm._e()
  }), _vm._v(" "), (_vm.qtype == 2) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.setRefAnswer(_vm.infoAnswer.options, _vm.infoAnswer.ref_info))
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.infoAnswer), function(val, stemIndex) {
    return (_vm.qtype == 3) ? _c('p', [_c('b', [_vm._v(_vm._s(stemIndex + 1) + ".")]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(val.stem)
      }
    })]) : _vm._e()
  }), _vm._v(" "), (_vm.qtype == 8) ? _c('p', [_vm._v(_vm._s(_vm.setAnswers(_vm.infoAnswer)))]) : _vm._e(), _vm._v(" "), (_vm.qtype == 6) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.setShortAnswer(_vm.infoAnswer))
    }
  }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.topicActive == 2) ? _c('div', {
    staticClass: "Topic_bg"
  }, _vm._l((_vm.knowledgePoints), function(item, index) {
    return _c('span', {
      staticClass: "topc_knowledgeP"
    }, [_vm._v(_vm._s(item.point_displayname))])
  })) : _vm._e(), _vm._v(" "), (_vm.topicActive == 3 && _vm.explains) ? _c('div', {
    staticClass: "Topic_bg"
  }, [_c('div', {
    staticClass: "clearfix m-b20",
    domProps: {
      "innerHTML": _vm._s(_vm.explains[0].context)
    }
  }), _vm._v(" "), _vm._l((_vm.explains[0].attachments), function(item, index) {
    return (_vm.explains[0].attachments.length > 0) ? _c('div', {
      staticClass: "m-b20"
    }, [(item.file_type == 2) ? _c('div', {
      staticClass: "button",
      class: _vm.myIsPlay ? 'play' : 'pause',
      on: {
        "click": _vm.player
      }
    }, [_c('audio', {
      attrs: {
        "src": item.file_url,
        "preload": "auto"
      }
    })]) : _vm._e(), _vm._v(" "), (item.file_type == 3 && _vm.videoP) ? _c('div', {
      staticClass: "coverUrl",
      on: {
        "click": _vm.videoPlayer
      }
    }, [_c('img', {
      staticClass: "coverVodio",
      attrs: {
        "src": item.cover_Url
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "coverUrlPlay",
      attrs: {
        "src": __webpack_require__(66)
      }
    })]) : _vm._e(), _vm._v(" "), _c('embed', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.file_type == 3 && !_vm.videoP),
        expression: "item.file_type==3 && !videoP"
      }],
      attrs: {
        "src": "http://yuntv.letv.com/bcloud.swf",
        "pic": "item.cover_Url",
        "allowFullScreen": "true",
        "quality": "high",
        "width": "300",
        "height": "150",
        "align": "middle",
        "allowScriptAccess": "always",
        "flashvars": _vm.videoSrc(item.file_url),
        "type": "application/x-shockwave-flash"
      }
    })]) : _vm._e()
  }), _vm._v(" "), (_vm.explains[0].lecturer) ? _c('div', [_c('b', [_vm._v("主讲教师:  ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.explains[0].lecturer))])]) : _vm._e(), _vm._v(" "), (_vm.explains[0].tags) ? _c('p', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, _vm._l((_vm.explains[0].tags.split(',')), function(tag, index) {
    return _c('span', {
      staticClass: "explains_tag"
    }, [_vm._v(_vm._s(tag))])
  })) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.topicActive == 4) ? _c('div', {
    staticClass: "Topic_bg"
  }, _vm._l((_vm.tags), function(item, index) {
    return _c('span', {
      staticClass: "explains_tag"
    }, [_vm._v(_vm._s(item))])
  })) : _vm._e(), _vm._v(" "), (_vm.topicActive == 5) ? _c('div', {
    staticClass: "Topic_bg"
  }, _vm._l((_vm.skillPoints), function(item, index) {
    return _c('span', {
      staticClass: "explains_tag"
    }, [_vm._v(_vm._s(item.point_displayname))])
  })) : _vm._e()]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.attachments.lenght) ? _c('div', {
    staticClass: "m-t10"
  }, _vm._l((_vm.attachments), function(data) {
    return _c('div', [(data.file_url) ? _c('div', {}, [(data.file_type == 1) ? _c('div', {
      staticClass: "img-box m-t20"
    }, [_c('img', {
      attrs: {
        "src": data.file_url,
        "alt": ""
      }
    })]) : (data.file_type == 2) ? _c('div', {
      staticClass: "m-t20"
    }, [_c('theAudio', {
      attrs: {
        "src": data.file_url,
        "id": _vm.id,
        "playerObj": _vm.playerObj
      },
      on: {
        "playedObj": _vm.playedObj
      }
    })], 1) : (data.file_type == 3) ? _c('div', {
      staticClass: "video m-t20 center"
    }, [(data.file_url.indexOf('letv://')) ? _c('video', {
      attrs: {
        "src": data.file_url,
        "controls": "controls",
        "preload": "auto"
      }
    }) : _c('embed', {
      attrs: {
        "src": "http://yuntv.letv.com/bcloud.swf",
        "allowFullScreen": "true",
        "quality": "high",
        "width": "300",
        "height": "150",
        "align": "middle",
        "allowScriptAccess": "always",
        "flashvars": _vm.videoSrc(data.file_url),
        "type": "application/x-shockwave-flash"
      }
    })]) : _vm._e()]) : _vm._e()])
  })) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "watchStuHead"
  }, [_c('div', {
    staticClass: "watContent"
  }, [_c('div', {
    staticClass: "watConTitle"
  }, [(_vm.useInfo.avatar && _vm.useInfo.avatar.length > 0) ? _c('img', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "src": _vm.useInfo.avatar
    }
  }) : _c('img', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "src": __webpack_require__(127)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "realName"
  }, [_c('p', {
    staticClass: "studenName"
  }, [_c('span', [_vm._v(_vm._s(_vm.useInfo.realName))])]), _vm._v(" "), _c('p', {
    staticClass: "studenNum"
  }, [_c('span', {
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v("学生号 : ")]), _c('span', [_vm._v(_vm._s(_vm.useInfo.userId))])])])]), _vm._v(" "), _c('ul', {
    staticClass: "stuConCount"
  }, [_c('li', [_c('b', {
    staticClass: "tabScore"
  }, [_vm._v(_vm._s(_vm._f("toMath")(_vm.userScore, 2, '-')))]), _vm._v(" "), _c('span', {
    staticClass: "tabScoreTip"
  }, [_vm._v("分数")])]), _vm._v(" "), _c('li', [_c('b', {
    staticClass: "tabScore"
  }, [_vm._v(_vm._s(_vm.userRank))]), _vm._v(" "), _c('span', {
    staticClass: "tabScoreTip"
  }, [_vm._v("名次")])])])])])
},staticRenderFns: []}

/***/ }),
/* 188 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view",
    staticStyle: {
      "padding": "10px 20px"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('watchStuHead', {
    attrs: {
      "useInfo": _vm.useInfo,
      "userScore": _vm.userScore,
      "userRank": _vm.userRank
    }
  }), _vm._v(" "), _c('exampaper', {
    attrs: {
      "page": _vm.page,
      "exampaperData": _vm.exampaperData,
      "userAnswers": _vm.userAnswers,
      "moduleId": _vm.moduleId,
      "isShowAnswer": _vm.isShowAnswer,
      "padShow": _vm.app_interaction
    },
    on: {
      "correctScore": _vm.correctScore
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 190 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('exampaper', {
    attrs: {
      "page": _vm.page,
      "exampaperData": _vm.exampaperData,
      "moduleId": _vm.moduleId,
      "thirdParty": _vm.thirdParty,
      "doworkTimes": _vm.doworkTime
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paper-question"
  }, [(_vm.webloading) ? _c('img', {
    staticClass: "loading",
    attrs: {
      "src": __webpack_require__(126)
    }
  }) : _c('div', {
    staticClass: "exampaperInfo"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.exampaper.title))]), _vm._v(" "), (_vm.page == 'selectOnlinePaper' || _vm.page == 'checkOnlinePaper') ? _c('span', {
    class: {
      paperBtn: _vm.paperBtnInfo, paperBtnActive: !_vm.paperBtnInfo
    },
    on: {
      "click": _vm.paperInfo
    }
  }, [_vm._v("试卷信息")]) : _vm._e(), _vm._v(" "), (_vm.page == 'selectOnlinePaper' || _vm.page == 'checkOnlinePaper') ? _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.paperBtnInfo),
      expression: "!paperBtnInfo"
    }],
    staticClass: "examPaper"
  }, [_c('div', {
    staticClass: "exam_top"
  }, [(_vm.exampaper.ref_score) ? _c('span', [_c('b', [_vm._v("总分:")]), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.exampaper.ref_score) + "分")])]) : _vm._e(), _vm._v(" "), _c('span', [_c('b', [_vm._v("总难度:")]), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.exampaper.difficultyDegree))])]), _vm._v(" "), _c('span', [_c('b', [_vm._v("总答题时间:")]), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.exampaper.ref_answer_time) + "分")])])]), _vm._v(" "), _c('div', {
    staticClass: "exam_tag"
  }, [(_vm.exampaper.videoReview) ? _c('div', [(_vm.videoPlay && _vm.exampaper.videoReview.coverUrl != null) ? _c('div', {
    staticClass: "coverUrl",
    on: {
      "click": _vm.videoPlayer
    }
  }, [_c('img', {
    staticClass: "coverUrl",
    attrs: {
      "src": _vm.exampaper.videoReview.coverUrl
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "coverUrlPlay",
    attrs: {
      "src": __webpack_require__(66)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.exampaper.videoReview.videoUnique != null && !_vm.videoPlay) ? _c('embed', {
    attrs: {
      "src": "http://yuntv.letv.com/bcloud.swf",
      "allowFullScreen": "true",
      "quality": "high",
      "width": "300",
      "height": "150",
      "align": "middle",
      "allowScriptAccess": "always",
      "flashvars": _vm.videoSrc(_vm.exampaper.videoReview.videoUnique),
      "type": "application/x-shockwave-flash"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.exampaper.testItems.length > 0) ? _c('ul', {
    staticClass: "exam_testItems"
  }, [_c('b', [_vm._v("考点信息:")]), _vm._v(" "), _vm._l((_vm.exampaper.testItems), function(item, index) {
    return _c('li', [_c('p', {
      staticClass: "paperInfoT"
    }, [_vm._v("• " + _vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticClass: "paperInfoC"
    }, [_vm._v(_vm._s(item.content))])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.exampaper.tags) ? _c('ul', {
    staticClass: "exam_tags"
  }, [_c('b', {
    staticClass: "paperInfoT"
  }, [_vm._v("来源")]), _vm._v(" "), _vm._l((_vm.exampaper.tags), function(item, index) {
    return _c('li', {
      staticClass: "paperInfoTag"
    }, [_vm._v("\n                                " + _vm._s(item) + "\n                            ")])
  })], 2) : _vm._e()])])]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.exampaper.parts), function(part, index) {
    return _c('div', {
      staticClass: "p-20 bg-fff border"
    }, [(_vm.page == 'selectListenSpeak' && _vm.selectFlag) ? _c('div', {
      staticClass: "fr"
    }, [_c('div', {
      staticClass: "button choice",
      class: {
        'checkedSel': part.isChecked, 'noCheck': !part.isChecked
      },
      on: {
        "click": function($event) {
          _vm.choiceBigQ(part, index)
        }
      }
    }, [_vm._v(_vm._s(part.buttonText))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "m-t10"
    }, [_c('p', {
      staticClass: "qDescript",
      domProps: {
        "innerHTML": _vm._s(part.module_description)
      }
    }), _vm._v(" "), (_vm.moduleId != 15) ? _c('p', {
      staticClass: "queNum"
    }, [_vm._v(_vm._s(_vm.questionNum[index]) + "、 (共 " + _vm._s(part.question_ref_sorce) + " 分, " + _vm._s(part.difficultyDegree) + " 难度)")]) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "qtypeName",
      domProps: {
        "innerHTML": _vm._s(part.module_type_name)
      }
    })]), _vm._v(" "), _vm._l((part.children), function(question, index) {
      return _c('div', {
        staticClass: "mt-20"
      }, [(question.qtype == 1) ? _c('singleChoice', {
        attrs: {
          "playerObj": _vm.playerObj,
          "question": question,
          "moduleId": _vm.moduleId,
          "id": question.id + index,
          "isShowAnswer": _vm.isShowAnswer
        },
        on: {
          "playedObj": _vm.playedObj
        }
      }) : (question.qtype == 2) ? _c('multipleChoice', {
        attrs: {
          "playerObj": _vm.playerObj,
          "id": question.id + index,
          "question": question,
          "moduleId": _vm.moduleId,
          "isShowAnswer": _vm.isShowAnswer
        },
        on: {
          "playedObj": _vm.playedObj
        }
      }) : (question.qtype == 3) ? _c('filling', {
        attrs: {
          "playerObj": _vm.playerObj,
          "id": question.id + index,
          "page": _vm.page,
          "question": question,
          "moduleId": _vm.moduleId,
          "isShowAnswer": _vm.isShowAnswer
        },
        on: {
          "playedObj": _vm.playedObj,
          "correctScore": _vm.correctScore
        }
      }) : (question.qtype == 4 || question.qtype == 9 || question.qtype == 10) ? _c('allFilling', {
        attrs: {
          "qtype": 9,
          "playerObj": _vm.playerObj,
          "id": question.id + index,
          "page": _vm.page,
          "question": question,
          "moduleId": _vm.moduleId,
          "isShowAnswer": _vm.isShowAnswer
        },
        on: {
          "playedObj": _vm.playedObj
        }
      }) : (question.qtype == 5) ? _c('reading', {
        attrs: {
          "playerObj": _vm.playerObj,
          "id": question.id + index,
          "question": question,
          "moduleId": _vm.moduleId,
          "isShowAnswer": _vm.isShowAnswer
        },
        on: {
          "playedObj": _vm.playedObj,
          "correctScore": _vm.correctScore
        }
      }) : (question.qtype == 6) ? _c('shortanswer', {
        attrs: {
          "playerObj": _vm.playerObj,
          "id": question.id + index,
          "page": _vm.page,
          "question": question,
          "moduleId": _vm.moduleId,
          "isShowAnswer": _vm.isShowAnswer,
          "padShow": _vm.padShow
        },
        on: {
          "playedObj": _vm.playedObj,
          "correctScore": _vm.correctScore
        }
      }) : (question.qtype == 7) ? _c('imitation', {
        attrs: {
          "playerObj": _vm.playerObj,
          "id": question.id + index,
          "question": question,
          "moduleId": _vm.moduleId,
          "isShowAnswer": _vm.isShowAnswer
        },
        on: {
          "playedObj": _vm.playedObj,
          "correctScore": _vm.correctScore
        }
      }) : (question.qtype == 8) ? _c('judge', {
        attrs: {
          "playerObj": _vm.playerObj,
          "id": question.id + index,
          "question": question,
          "moduleId": _vm.moduleId,
          "isShowAnswer": _vm.isShowAnswer
        },
        on: {
          "playedObj": _vm.playedObj
        }
      }) : _vm._e()], 1)
    })], 2)
  })], 2), _vm._v(" "), ((_vm.page == 'selectListenSpeak' || _vm.page == 'selectOnlinePaper') && this.thirdParty) ? _c('div', {
    staticClass: "m-select-question",
    class: {
      relativeBox: _vm.barHide
    }
  }, [_c('div', {
    staticClass: "clearfix"
  }, [(_vm.selectedExampaperArr.length) ? _c('div', {
    staticClass: "fl"
  }, [_vm._v("共选 " + _vm._s(_vm.selectedExampaperArr.length || 0) + " 条内容，预计\n                "), _c('span', {
    staticStyle: {
      "padding": "0px 5px"
    }
  }, [_vm._v(" " + _vm._s(_vm._f("formatDataToMinutes")(_vm.doworkTime)) + " ")]), _vm._v("分钟")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [(_vm.selectFlag) ? _c('div', {
    staticClass: "inline-block",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button inline-block m-l20 surebtn",
    on: {
      "click": _vm.backQuestionArr
    }
  }, [_vm._v("确定")])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 192 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": _vm.videoId
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 193 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qStem"
  }, [_c('div', [_c('p', {
    staticClass: "qDescript",
    domProps: {
      "innerHTML": _vm._s(_vm.question.question_description)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-20"
  }, [(_vm.question.sid > -1 && _vm.moduleId != 15) ? _c('span', {
    staticClass: "queNum"
  }, [_vm._v(" " + _vm._s(_vm.question.sid + 1) + ". ")]) : _vm._e(), _vm._v(" "), (_vm.question.question_ref_sorce) ? _c('span', [_vm._v("(" + _vm._s(_vm.question.question_ref_sorce || 0) + "分, " + _vm._s(_vm.question.difficultyDegree) + "难度)")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "qStemC"
  }, [_c('div', {
    staticClass: "qsamllStem",
    domProps: {
      "innerHTML": _vm._s(_vm.question.stem)
    }
  }), _vm._v(" "), _c('attachments', {
    attrs: {
      "attachments": _vm.question.attachments,
      "playerObj": _vm.playerObj,
      "id": _vm.question.id
    },
    on: {
      "playedObj": _vm.playedObj
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "option-box clearfix"
  }, _vm._l((_vm.question.options), function(option, opIndex) {
    return _c('div', {
      staticClass: "option-item"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("fromCharCode")(opIndex)) + ".")]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(option.stem)
      }
    }), _vm._v(" "), _c('attachments', {
      attrs: {
        "attachments": option.attachments,
        "playerObj": _vm.playerObj,
        "id": _vm.question.id
      },
      on: {
        "playedObj": _vm.playedObj
      }
    })], 1)
  })), _vm._v(" "), (_vm.isShowAnswer) ? _c('div', [_c('div', {
    staticClass: "u-question-item"
  }, [_c('span', {
    staticClass: "color-999999"
  }, [_vm._v("学生答案：")]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.setUserAnswer(_vm.question.options, _vm.question.userAnswer))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [_c('div', {
    staticClass: "assessIconBox",
    domProps: {
      "innerHTML": _vm._s(_vm.setAssessIcon(_vm.question.userAnswer))
    }
  }), _vm._v(" "), _c('span', [_vm._v("（"), _c('span', {
    staticClass: "col-red",
    domProps: {
      "innerHTML": _vm._s(_vm.setAssess(_vm.question.userAnswer))
    }
  }), _vm._v(" / " + _vm._s(parseFloat(_vm.question.question_ref_sorce)) + "分）")])])])]) : _vm._e(), _vm._v(" "), (_vm.moduleId == 15) ? _c('listenTabTopic', {
    attrs: {
      "infoAnswer": _vm.question,
      "listenTextModule": _vm.question.textModule[0],
      "qtype": 2
    }
  }) : (_vm.moduleId == 124) ? _c('tabTopic', {
    attrs: {
      "isObject": false,
      "infoAnswer": _vm.question,
      "knowledgePoints": _vm.question.knowledge_points,
      "skillPoints": _vm.question.skill_points,
      "explains": _vm.question.explains,
      "qtype": 2,
      "tags": _vm.question.tags
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 194 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qStem"
  }, [_c('p', {
    staticClass: "qDescript",
    domProps: {
      "innerHTML": _vm._s(_vm.question.question_description)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-20"
  }, [(_vm.question.sid > -1 && _vm.moduleId != 15) ? _c('span', {
    staticClass: "queNum"
  }, [_vm._v(_vm._s(_vm.question.sid + 1) + ". ")]) : _vm._e(), _vm._v(" "), (_vm.question.question_ref_sorce) ? _c('b', [_vm._v("(" + _vm._s(_vm.question.question_ref_sorce || 0) + "分, " + _vm._s(_vm.question.difficultyDegree) + "难度)")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "qStemC"
  }, [_c('div', {
    staticClass: "qsamllStem",
    domProps: {
      "innerHTML": _vm._s(_vm.question.stem)
    }
  }), _vm._v(" "), _c('attachments', {
    attrs: {
      "attachments": _vm.question.attachments,
      "playerObj": _vm.playerObj,
      "id": _vm.question.id
    },
    on: {
      "playedObj": _vm.playedObj
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "option-box clearfix"
  }, _vm._l((_vm.question.options), function(option, opIndex) {
    return _c('div', {
      staticClass: "option-item"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("fromCharCode")(opIndex)) + ".")]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(option.stem)
      }
    }), _vm._v(" "), _c('attachments', {
      attrs: {
        "playerObj": _vm.playerObj,
        "id": _vm.question.id,
        "attachments": option.attachments
      },
      on: {
        "playedObj": _vm.playedObj
      }
    })], 1)
  })), _vm._v(" "), (_vm.isShowAnswer) ? _c('div', [_c('div', {
    staticClass: "u-question-item"
  }, [_c('span', {
    staticClass: "color-999999"
  }, [_vm._v("学生答案：")]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.setUserAnswer(_vm.question.options, _vm.question.userAnswer))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "u-shortAnswer"
  }, [_c('div', {
    staticClass: "assessIconBox",
    domProps: {
      "innerHTML": _vm._s(_vm.setAssessIcon(_vm.question.userAnswer))
    }
  }), _vm._v(" "), _c('span', [_vm._v("（"), _c('span', {
    staticClass: "col-red",
    domProps: {
      "innerHTML": _vm._s(_vm.setAssess(_vm.question.userAnswer))
    }
  }), _vm._v(" / " + _vm._s(parseFloat(_vm.question.question_ref_sorce)) + "分）")])])])]) : _vm._e(), _vm._v(" "), (_vm.moduleId == 15) ? _c('listenTabTopic', {
    attrs: {
      "infoAnswer": _vm.question.ref_info.answers,
      "listenTextModule": _vm.question.textModule,
      "qtype": 1
    }
  }) : _vm._e(), _vm._v(" "), (_vm.moduleId == 124) ? _c('tabTopic', {
    attrs: {
      "isObject": false,
      "infoAnswer": _vm.question.ref_info.answers,
      "knowledgePoints": _vm.question.knowledge_points,
      "skillPoints": _vm.question.skill_points,
      "explains": _vm.question.explains,
      "qtype": 1,
      "tags": _vm.question.tags
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 195 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 196 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qStem"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.question.question_description)
    }
  }), _vm._v(" "), (_vm.question.sid > -1 && _vm.moduleId != 15) ? _c('span', {
    staticClass: "queNum"
  }, [_vm._v(" " + _vm._s(_vm.question.sid + 1) + ". ")]) : _vm._e(), _vm._v(" "), (_vm.question.question_ref_sorce) ? _c('span', [_vm._v("(" + _vm._s(_vm.question.question_ref_sorce || 0) + "分, " + _vm._s(_vm.question.difficultyDegree) + "难度)")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "qStemC"
  }, [_c('div', {
    staticClass: "qsamllStem",
    domProps: {
      "innerHTML": _vm._s(_vm.question.stem)
    }
  }), _vm._v(" "), _c('attachments', {
    attrs: {
      "attachments": _vm.question.attachments,
      "playerObj": _vm.playerObj,
      "id": _vm.question.id
    },
    on: {
      "playedObj": _vm.playedObj
    }
  }), _vm._v(" "), (_vm.moduleId == 124) ? _c('tabTopic', {
    attrs: {
      "infoAnswer": _vm.question.ref_info && _vm.question.ref_info.answers[0],
      "knowledgePoints": _vm.question.knowledge_points,
      "skillPoints": _vm.question.skill_points,
      "explains": _vm.question.explains,
      "tags": _vm.question.tags,
      "qtype": 5,
      "isObject": true
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.question.children), function(question, index) {
    return _c('div', {
      staticClass: "m-t20"
    }, [(question.qtype == 1) ? _c('singleChoice', {
      attrs: {
        "question": question,
        "playerObj": _vm.playerObj,
        "moduleId": _vm.moduleId,
        "parentqtype": question.qtype,
        "isShowAnswer": _vm.isShowAnswer
      },
      on: {
        "playedObj": _vm.playedObj
      }
    }) : (question.qtype == 2) ? _c('multipleChoice', {
      attrs: {
        "question": question,
        "playerObj": _vm.playerObj,
        "moduleId": _vm.moduleId,
        "isShowAnswer": _vm.isShowAnswer
      },
      on: {
        "playedObj": _vm.playedObj
      }
    }) : (question.qtype == 3) ? _c('filling', {
      attrs: {
        "question": question,
        "playerObj": _vm.playerObj,
        "moduleId": _vm.moduleId,
        "parentqtype": question.qtype,
        "isShowAnswer": _vm.isShowAnswer
      },
      on: {
        "playedObj": _vm.playedObj,
        "correctScore": _vm.correctScore
      }
    }) : (question.qtype == 4) ? _c('allFilling', {
      attrs: {
        "question": question,
        "playerObj": _vm.playerObj,
        "moduleId": _vm.moduleId,
        "isShowAnswer": _vm.isShowAnswer
      },
      on: {
        "playedObj": _vm.playedObj,
        "correctScore": _vm.correctScore
      }
    }) : (question.qtype == 6) ? _c('shortanswer', {
      attrs: {
        "question": question,
        "id": question.id + index,
        "playerObj": _vm.playerObj,
        "moduleId": _vm.moduleId,
        "parentqtype": question.qtype,
        "isShowAnswer": _vm.isShowAnswer
      },
      on: {
        "playedObj": _vm.playedObj,
        "correctScore": _vm.correctScore
      }
    }) : (question.qtype == 7) ? _c('imitation', {
      attrs: {
        "question": question,
        "playerObj": _vm.playerObj,
        "moduleId": _vm.moduleId,
        "parentqtype": question.qtype,
        "isShowAnswer": _vm.isShowAnswer
      },
      on: {
        "playedObj": _vm.playedObj,
        "correctScore": _vm.correctScore
      }
    }) : (question.qtype == 8) ? _c('judge', {
      attrs: {
        "question": question,
        "playerObj": _vm.playerObj,
        "moduleId": _vm.moduleId,
        "isShowAnswer": _vm.isShowAnswer
      },
      on: {
        "playedObj": _vm.playedObj
      }
    }) : _vm._e()], 1)
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fetch__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_question_exampaper_vue__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_question_exampaper_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_question_exampaper_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_watchStuHead_watchStuHead_vue__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_watchStuHead_watchStuHead_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_watchStuHead_watchStuHead_vue__);

//
//
//
//
//
//
//

 // 接口
 // 所有题型组件



/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		exampaper: __WEBPACK_IMPORTED_MODULE_2__components_question_exampaper_vue___default.a,
		watchStuHead: __WEBPACK_IMPORTED_MODULE_4__components_watchStuHead_watchStuHead_vue___default.a
	},
	data: function data() {
		return {
			page: 'checkOnlinePaper', // 当前页面
			moduleId: 124, // 资源模块, 15[听说模考] / 124[在线作答]
			isShowAnswer: true,
			versionId: '', // 试卷ID 	4675443382047446397
			doWorkId: '', // 8176483212442072	
			exampaperData: null, // 试卷信息
			userAnswers: null, // 用户试卷答案
			showdata: null,
			useInfo: [],
			userScore: 0, // 显示的选题 Array(题目下标)
			userRank: 0,
			correctContents: [],
			actualScore: 0, //总分
			app_interaction: false

		};
	},
	created: function created() {
		var _this = this;

		var record = JSON.parse(this.$route.query.record);
		this.versionId = record.versionId;
		this.doWorkId = record.doWorkId;
		this.useInfo = record.userId;
		this.userRank = record.index;
		this.userScore = record.actualScore;
		this.$nextTick(function () {
			_this.setCrumb('查看详情');
			_this.app_interaction = window.localStorage.getItem('app_interaction');
			//获取用户信息  
		});
		__WEBPACK_IMPORTED_MODULE_1__fetch__["a" /* default */].getInfo({ userId: this.useInfo }).then(function (res) {
			if (!res) {
				return false;
			}
			_this.useInfo = res.data;
		});
		this.getOnlineAnswer(this.doWorkId);
		this.getOnlineExamination(this.versionId);
	},

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['setCrumb']), {
		correctScore: function correctScore(_correctScore) {
			this.correctContents = [];
			this.actualScore = 0;
			for (var i = 0, lenA = this.userAnswers.length; i < lenA; i++) {
				var itemA = this.userAnswers[i];
				if (itemA.versionId == _correctScore.versionId) {
					itemA = _correctScore;
				}
				this.actualScore += itemA.score * 1;
				this.correctContents.push(itemA);
			}
			this.userAnswers = this.correctContents;
			this.userScore = this.actualScore;
			var data = {
				"doWorkId": this.doWorkId,
				"actualScore": this.actualScore,
				correctContents: this.correctContents
			};
			this.sentWorkSorce(data);
		},
		sentWorkSorce: function sentWorkSorce(data) {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_1__fetch__["a" /* default */].correctWork(data).then(function (res) {
				if (!res) {
					return false;
				}
				_this2.$toast("批改成功", "right");
			}, function (err) {
				console.log(err);
			});
		},
		getOnlineAnswer: function getOnlineAnswer(doWorkId) {
			var _this3 = this;

			__WEBPACK_IMPORTED_MODULE_1__fetch__["a" /* default */].getWorkAnswers({ doWorkId: this.doWorkId }).then(function (res) {
				if (!res) {
					return false;
				}
				_this3.userAnswers = res.data;
			}, function (err) {
				console.log(err);
			});
		},
		getOnlineExamination: function getOnlineExamination(versionId) {
			var _this4 = this;

			// 获取在线作答试卷
			__WEBPACK_IMPORTED_MODULE_1__fetch__["a" /* default */].getOnlineExamination({ versionId: versionId }).then(function (res) {
				if (!res) {
					return false;
				}
				_this4.exampaperData = res.data;
			}, function (err) {
				console.log(err);
			});
		}
	})
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

//
//
//
//
//
//
//
//
//
//

// 音频组件
/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            myIsPlay: false,
            toParentIsPlay: false,
            audio: null,
            index: 0,
            stopPlayAll: false
        };
    },

    props: ['playerObj', 'src', 'id', 'allUrl'],
    watch: {
        playerObj: function playerObj(newVal, oldVal) {
            if (newVal == oldVal || !this.audio) {
                return false;
            }

            if (!newVal.id && newVal.id == this.id) {
                if (this.playerObj.isPlay) {
                    this.myIsPlay = true;

                    this.index = 0;
                    this.allPlay();
                } else {
                    this.myIsPlay = false;
                    this.stopPlayAll = true;
                }
                return false;
            }

            if (newVal.id == this.id && this.playerObj.isPlay) {
                this.myIsPlay = true;

                this.stopPlayAll = true;
                this.allPause();
                this.audio.play();
                this.playEnd();
            } else {
                this.audio.pause();
                this.myIsPlay = false;
            }
        }
    },
    methods: {
        player: function player(event) {
            this.audio = event.target.querySelector('audio');
            this.$emit('playedObj', { id: this.id, isPlay: !this.myIsPlay });
        },
        playEnd: function playEnd(cb) {
            var _this = this;
            this.audio.addEventListener('ended', function () {
                _this.myIsPlay = false;
                if (cb) {
                    cb();
                }
            });
        },
        allPause: function allPause() {
            var audios = document.querySelectorAll('audio');
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(audios), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    item.pause();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        allPlay: function allPlay() {
            var that = this;
            var urls = this.allUrl;
            // let len = urls.length;

            console.log(this.index);
            if (that.stopPlayAll) {
                console.log(0, 0);
                return false;
            }

            // this.audio.src = urls[this.index];
            // that.audio.load();
            // this.audio.addEventListener('loadedmetadata', function(){
            //     that.audio.play();
            //     that.playEnd(function(){
            //         that.index++;
            //         if(that.index >= len){
            //             return false;
            //         }
            //         that.allPlay()
            //     });
            //     console.log('current source num', this.index)

            // })

            /*****************************************/

            var audios = document.querySelectorAll('audio');
            var len = audios.length;

            this.loopPlay();
        },
        loopPlay: function loopPlay() {
            var that = this;
            var len = this.allUrl.length;
            var audio = document.getElementById(this.allUrl[this.index]).children[0];
            // if(this.stopPlayAll) {
            //     console.log(11111111111)
            //     return false;
            // }
            audio.play();
            audio.addEventListener('ended', function () {
                that.index++;
                if (that.index >= len || that.stopPlayAll) {
                    return false;
                }
                console.log('current source num', that.index);

                that.loopPlay();
            });
        },
        play: function play() {
            this.myIsPlay = true;
            this.audio.play();
            this.playEnd();
        }
    }
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      videoId: 'video_' + +new Date(),
      letvPlayer: null
    };
  },

  props: ['pic', 'videoVu'],
  created: function created() {
    this.$nextTick(function () {
      this.loadJsLeVideo();
    });
  },

  methods: {
    videoPlay: function videoPlay() {
      this.letvPlayer.sdk.replayVideo();
    },

    // 载入乐视视频
    loadJsLeVideo: function loadJsLeVideo() {
      if (typeof CloudVodPlayer == 'function') {
        var letvPlayer = new CloudVodPlayer();
        letvPlayer.init({ "loadingpic": "./../../assets/img/loadingOnline.gif", "vu": this.videoVu.substr(7), "bgcolor": this.pic, "pu": "B6999F08EC", "uu": "2bfc338ed7", "posterType": 2, "gpcflag": 1, "skinnable": 0, "width": "300", "height": "150", "lang": "zh_CN", "callbackJs": function callbackJs(e) {
            console.log(1111, e);
          } }, this.videoId);
        // setTimeout(function(){
        // 	// console.log(1)
        // 	// debugger
        // 	letvPlayer.sdk.pauseVideo()
        // },6000)
        this.letvPlayer = letvPlayer;
      } else {
        // 没有乐视类就加载乐视js
        this.loadLetvJS();
      }
    },
    // 载入乐视js
    loadLetvJS: function loadLetvJS(callback) {
      var _this = this;
      var script = document.createElement('script');
      script.src = location.protocol + '//yuntv.letv.com/player/vod/bcloud.js';
      script.onload = function () {
        _this.loadJsLeVideo();
        if (callback) callback();
      };
      document.body.appendChild(script);
    }
  }
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
     props: ["imgSrc"],
     data: function data() {
          return {
               imgFlag: true
          };
     },

     methods: {
          imgFun: function imgFun() {
               this.imgFlag = false;
               this.$emit("imgBigShow", this.imgFlag);
          }
     }
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tabTopic_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tabTopic_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tabTopic_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__listenTabTopic_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__listenTabTopic_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__listenTabTopic_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__attachments_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__attachments_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__attachments_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__singleChoice_vue__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__singleChoice_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__singleChoice_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filling_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filling_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__filling_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shortanswer_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shortanswer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__shortanswer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__imitation_vue__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__imitation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__imitation_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 阅读理解,该题型包含小题，小题类型有：1单选图、6简答题、7模仿朗读
 // 附件
 // 听说的tab
 // 附件
 // 1单选题
 // 3填空题
 // 6简答题
 // 7模仿朗读or简答题

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },

    props: ['page', 'moduleId', 'question', 'isShowAnswer', 'playerObj', 'qtype'],
    components: {
        attachments: __WEBPACK_IMPORTED_MODULE_2__attachments_vue___default.a,
        singleChoice: __WEBPACK_IMPORTED_MODULE_3__singleChoice_vue___default.a,
        filling: __WEBPACK_IMPORTED_MODULE_4__filling_vue___default.a,
        shortanswer: __WEBPACK_IMPORTED_MODULE_5__shortanswer_vue___default.a,
        imitation: __WEBPACK_IMPORTED_MODULE_6__imitation_vue___default.a,
        tabTopic: __WEBPACK_IMPORTED_MODULE_0__tabTopic_vue___default.a,
        listenTabTopic: __WEBPACK_IMPORTED_MODULE_1__listenTabTopic_vue___default.a
    },
    mounted: function mounted() {// 同v1.*的ready

    },

    computed: {
        // debugger;
    },
    methods: {
        // 格式化填空
        fillFormatHtml: function fillFormatHtml(val) {
            var data = val;
            if (this.qtype == 9) {
                data = data.replace(/\s+style="[^"]*"/g, '');
            }
            return data.replace(/{#blank#}(\d*){#\/blank#}/g, '<span class="filling-txt"><i class="filling_bg">$1</i></span>');
        },
        playedObj: function playedObj(playerObj) {
            this.$emit('playedObj', playerObj);
        },
        correctScore: function correctScore(_correctScore) {
            this.$emit('correctScore', _correctScore);
        }
    }
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__player_audio_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__player_audio_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__player_audio_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 附件
 // 音频组件
/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            letvFile: 1
        };
    },

    props: ['attachments', 'playerObj', 'id'],
    components: {
        theAudio: __WEBPACK_IMPORTED_MODULE_0__player_audio_vue___default.a
    },
    watch: {},
    created: function created() {
        this.$nextTick(function () {
            // this.handleUrl();
        });
    },
    mounted: function mounted() {// 同v1.*的ready

    },

    computed: {},
    methods: {
        handleUrl: function handleUrl(data) {
            var flagLetv = data.indexOf('letv://');
            if (flagLetv) {
                this.letvFile = 0;
            } else {
                return data;
            }
        },
        playedObj: function playedObj(playerObj) {
            this.$emit('playedObj', playerObj);
        },

        videoSrc: function videoSrc(item) {
            var src = item.substr(7);
            return 'pu=B6999F08EC&uu=2bfc338ed7&vu=' + src + '&auto_play=1&width=656&height=504';
        }
    }
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__singleChoice_vue__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__singleChoice_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__singleChoice_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__multipleChoice_vue__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__multipleChoice_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__multipleChoice_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filling_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filling_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__filling_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__allFilling_vue__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__allFilling_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__allFilling_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reading_vue__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__reading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shortanswer_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shortanswer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__shortanswer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__imitation_vue__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__imitation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__imitation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__judge_vue__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__judge_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__judge_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(28);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 试卷
 // 1单选题
 // 2多选题
 // 3填空题
 // 4完形填空 9 短文改错 10 语篇填空题
 // 5阅读理解
 // 6简答题
 // 7模仿朗读or简答题
 // 8判断题



/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        singleChoice: __WEBPACK_IMPORTED_MODULE_2__singleChoice_vue___default.a,
        multipleChoice: __WEBPACK_IMPORTED_MODULE_3__multipleChoice_vue___default.a,
        filling: __WEBPACK_IMPORTED_MODULE_4__filling_vue___default.a,
        judge: __WEBPACK_IMPORTED_MODULE_9__judge_vue___default.a,
        allFilling: __WEBPACK_IMPORTED_MODULE_5__allFilling_vue___default.a,
        reading: __WEBPACK_IMPORTED_MODULE_6__reading_vue___default.a,
        shortanswer: __WEBPACK_IMPORTED_MODULE_7__shortanswer_vue___default.a,
        imitation: __WEBPACK_IMPORTED_MODULE_8__imitation_vue___default.a
    },
    data: function data() {
        return {
            exampaper: { parts: [] },
            barHide: false,
            myUserAnswers: [],
            playerObj: 0,
            checkedResource: '',
            webloading: true,
            selectedExampaperArr: [],
            videoPlay: true,
            paperBtnInfo: true,
            questionNum: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二'],
            doworkTime: 0
        };
    },

    props: ['page', 'selectFlag', 'moduleId', // 资源模块, 15[听说模考] / 124[在线作答]
    'exampaperData', // 试卷
    'userAnswers', // 用户答案
    'showdata', // 作业详情【显示的选题】
    'isShowAnswer', 'packageId', 'cId', 'serviceId', 'versionId', 'padShow', 'thirdParty', 'doworkTimes'],
    watch: {
        barHide: function barHide(val) {
            this.barHide = val;
        },
        exampaperData: function exampaperData(val) {
            this.exampaperData = val;
            if (this.thirdParty) {
                var contents = this.getWorks().contents;
                if (this.page == 'selectListenSpeak' || this.page == 'selectOnlinePaper') {
                    for (var i = 0, len = contents.length; i < len; i++) {
                        if (this.versionId == contents[i].versionId) {
                            this.checkedResource = contents[i].checkedResource;
                        }
                    }
                    // if(this.exampaperData.checkedResourceEmpty==0){
                    //    this.checkedResource = [];
                    // }
                    //给每个数据加上一个选中字段
                    if (this.selectFlag) {
                        for (var i = 0, len = this.exampaperData.parts.length; i < len; i++) {
                            var item = this.exampaperData.parts[i];
                            item.isChecked = false;
                            item.buttonText = "选择大题";
                            if (this.checkedResource.length == 0 || this.checkedResource.indexOf(i) > -1) {
                                this.selectedExampaperArr.push(i);
                                item.isChecked = true;
                                item.buttonText = "取消选择";
                            }
                        }
                    }
                    if (this.page == 'selectListenSpeak') {
                        this.doworkTime = this.selectedExampaperArr.length * 180 || this.exampaperData.parts.length * 180;
                    } else if (this.page == 'selectOnlinePaper') {
                        this.doworkTime = this.doworkTimes * 60;
                    }
                }
            }
            this.mergeAnswerToExampaper();
        },
        userAnswers: function userAnswers(val) {
            this.myUserAnswers = val;
            if (this.myUserAnswers && this.exampaperData) {
                this.mergeAnswerToExampaper();
            }
        },
        exampaper: function exampaper(val) {
            // 空数组为全选状态
            if (this.selectedExampaperArr && this.selectedExampaperArr.length == 0 && this.exampaper.parts) {
                for (var i = 0; i < this.exampaper.parts.length; i++) {
                    this.selectedExampaperArr.push(i);
                }
            }
        }
    },
    created: function created() {},

    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["c" /* mapGetters */])(['getWorks']), {
        choiceBigQ: function choiceBigQ(item, index) {

            item.isChecked = !item.isChecked;
            this.exampaperData.parts[index] = item;
            this.selectedExampaperArr = [];
            for (var i = 0, len = this.exampaperData.parts.length; i < len; i++) {
                var item = this.exampaperData.parts[i];
                if (item.isChecked) {
                    item.buttonText = "取消选择";
                    this.selectedExampaperArr.push(i);
                } else if (!item.isChecked) {
                    item.buttonText = "选择大题";
                }
            }

            this.doworkTime = this.selectedExampaperArr.length * 180 || this.exampaperData.parts.length * 180; // 等于0的时候就是全选
        },
        back: function back() {
            if (this.selectFlag) {
                this.$router.push({ path: "publishHomeWork", query: { serviceId: this.serviceId, packageId: this.packageId, cId: this.cId, isFirst: 0 } });
            } else {
                this.$router.back(-1);
            }
        },

        // 题目数组回传
        backQuestionArr: function backQuestionArr() {
            var _this2 = this;

            if (this.selectFlag) {
                (function () {
                    var count = _this2.selectedExampaperArr.length;
                    var score = 0;
                    //累加选中的题目分值
                    for (var i = 0, len = _this2.selectedExampaperArr.length; i < len; i++) {
                        var item = _this2.exampaper.parts[_this2.selectedExampaperArr[i]].children;
                        if (item.length > 1) {
                            item.forEach(function (item1, index1) {
                                score = score + item1.question_ref_sorce;
                            });
                        } else if (item.length === 1) {
                            if (item[0].children.length > 0) {
                                for (var j = 0, len1 = item[0].children.length; j < len1; j++) {
                                    score = score + item[0].children[j].question_ref_sorce;
                                }
                            } else if (item[0].children.length === 0) {

                                score = score + item[0].question_ref_sorce;
                            }
                        }
                    }
                    if (_this2.selectedExampaperArr.length === 0) {
                        count = _this2.exampaper.parts.length;
                    }
                    if (_this2.exampaper.parts && _this2.selectedExampaperArr.length == _this2.exampaper.parts.length && _this2.selectedExampaperArr.length === 0) {
                        // 全选状态为空数组
                        _this2.selectedExampaperArr = [];
                        score = _this2.exampaper.ref_score;
                    }
                    _this2.$emit('submitExampaper', _this2.selectedExampaperArr, count, score, _this2.exampaperData.parts.length);
                })();
            } else {
                this.$router.back(-1);
            }
        },

        // 合并答案到试卷
        mergeAnswerToExampaper: function mergeAnswerToExampaper() {
            var exampaperData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.exampaperData));
            var userAnswers = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.myUserAnswers));
            exampaperData = this.showPartList(exampaperData, this.showdata);
            for (var index = 0; index < exampaperData.parts.length; index++) {
                exampaperData.parts[index] = this.setUserAnswer(exampaperData.parts[index], userAnswers);
                exampaperData.parts[index] = this.sortAttachments(exampaperData.parts[index]);
            }

            this.exampaper = exampaperData;
            this.webloading = false;
        },

        // --------------------------答案处理函数-----------------------------------------
        // 只显示老师布置的作业题
        showPartList: function showPartList(result, showdata) {
            if (showdata && showdata.length > 0) {
                var _showdata = showdata.split(",");
                var arrayObj = new Array(); //创建一个数组
                _showdata.forEach(function (d, i) {
                    var l = result.parts.length - 1;
                    if (d <= l) {
                        var ret = result.parts[d];
                        arrayObj.push(ret);
                    }
                });
                var _result = { title: result.title, ref_score: result.ref_score, curriculum_id: result.curriculum_id, parts: arrayObj, id: result.id, version_id: result.version_id };
                result = _result;
            }
            return result;
        },
        // 设置参考答案
        // answerIdArr:正确答案选项组，options：题目选项
        setRefAnswer: function setRefAnswer(question) {
            // if(!question) return false;
            var answerIdArr = question.ref_info.answers;
            var options = question.options;
            var result = [],
                arr = [];
            // 选择题答案解析
            if (question.qtype == 1) {
                for (var i = 0; i < answerIdArr.length; i++) {
                    for (var j = 0; j < options.length; j++) {
                        options[j].is_answer = false;
                        if (options[j].id == answerIdArr[i]) {
                            options[j].index = j;
                            options[j].is_answer = true;
                            arr.push(options[j]);
                            break;
                        }
                    };
                }
            }

            if (arr != '') {
                question.options = options;
                question.ref_info.answers = arr;
            }
            this.webloading = false;
            return question;
        },
        // 设置用户答案
        setUserAnswer: function setUserAnswer(questions, userAnswers) {
            var _this = this;
            if (questions && questions.children) {
                questions.children.forEach(function (question, index) {
                    question = _this.setRefAnswer(question);
                    question.userAnswer = _this.findUserAnswer(userAnswers, question.version_id);
                    question.children && question.children.length > 0 && _this.setUserAnswer(question, userAnswers);
                    questions.children[index] = question;
                });
            }
            return questions;
        },
        // 查找对应试卷id用户答案
        findUserAnswer: function findUserAnswer(userAnswers, versionId) {
            var result;
            userAnswers.forEach(function (m) {
                if (m.versionId && m.versionId == versionId || m.version_id && m.version_id == versionId) {
                    result = m;
                }
            });
            if (result && !(result.answers instanceof Array)) {
                result.answers = JSON.parse(result.answers);
            }
            return result;
        },
        // 附件排序
        sortAttachments: function sortAttachments(questions) {
            if (questions && questions.children) {
                questions.children.forEach(function (question, index) {
                    var atta = question.attachments,
                        audioArr = [],
                        imgArr = [],
                        videoArr = [];
                    for (var i = 0, len = atta.length; i < len; i++) {
                        if (atta[i].file_type == 1) imgArr.push(atta[i]);
                        if (atta[i].file_type == 2) audioArr.push(atta[i]);
                        if (atta[i].file_type == 3) videoArr.push(atta[i]);
                    }
                    question.attachments = audioArr.concat(videoArr).concat(imgArr);
                    questions.children[index] = question;
                });
            }
            return questions;
        },
        videoSrc: function videoSrc(item) {
            return 'pu=B6999F08EC&uu=2bfc338ed7&vu=' + item + '&auto_play=1&width=656&height=504';
        },
        paperInfo: function paperInfo() {
            this.paperBtnInfo = !this.paperBtnInfo;
        },
        videoPlayer: function videoPlayer() {
            this.videoPlay = false;
        },
        playedObj: function playedObj(playerObj) {
            this.playerObj = playerObj;
        },
        correctScore: function correctScore(_correctScore) {
            this.$emit('correctScore', _correctScore);
        }
    })
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attachments_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attachments_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__attachments_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tabTopic_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tabTopic_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tabTopic_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listenTabTopic_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listenTabTopic_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__listenTabTopic_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 填空题

 // 附件
 // 听说的tab
/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            fillIndex: '',
            handle: -1,
            scoreVal: '0',
            Cright: true,
            halfRight: true,
            C_error: true,
            correctContents: '',
            changeAnswer: ''
        };
    },

    props: ['page', 'question', 'parentqtype', 'isShowAnswer', 'moduleId', 'playerObj'],
    created: function created() {
        var _this = this;

        document.body.addEventListener("click", function () {
            _this.handle = -1;
        });
        // this.altData();
        this.$nextTick(function () {
            _this.altData();
        });
    },

    watch: {
        question: function question(old) {
            this.altData();
        }
    },
    components: {
        attachments: __WEBPACK_IMPORTED_MODULE_0__attachments_vue___default.a,
        tabTopic: __WEBPACK_IMPORTED_MODULE_1__tabTopic_vue___default.a,
        listenTabTopic: __WEBPACK_IMPORTED_MODULE_2__listenTabTopic_vue___default.a
    },
    methods: {
        altData: function altData() {
            var options = this.question.options;
            for (var i = 0; i < options.length; i++) {
                var stem = options[i].stem;
                try {
                    stem = JSON.parse(stem);
                    if (stem instanceof Array) {
                        options[i].stem = stem.join('/');
                    }
                } catch (e) {}
            }
            this.question.options = [];
            this.question.options = options;
        },

        // 格式化{}填空
        fillFormatHtml: function fillFormatHtml(val) {
            return val.replace(/{#blank#}(\d*){#\/blank#}/g, '<span class="filling-txt"><i class="filling_bg">$1</i></span>');
        },

        // 设置填空题得分(0:未批改 1:对 2:错 3:半对 4:未知)
        setAssessFilling: function setAssessFilling(question, index) {
            var html;
            var theAnswer;
            question.userAnswer && question.userAnswer.answers.forEach(function (answer) {
                if (answer.sid == index) return theAnswer = answer;
            });

            if (theAnswer !== undefined) {
                if (theAnswer.assess === 0) {
                    // 未批改
                    html = '评分中';
                } else if (theAnswer.assess === 4) {
                    return '<i class="f-status f-unknown"></i> 分';
                } else {
                    html = theAnswer.assess == 1 ? (question.question_ref_sorce / question.options.length).toFixed(1) || 0 : theAnswer.score || theAnswer.item_score || 0;
                    html = parseFloat(html) + '分';
                }
            } else {
                html = 0 + '分';
            }

            return html;
        },

        // 设置得分的标签(assess= undefined或6:未作答  0:未批改 1:对 2:错 3:半对 4:未知  5:批改失败)
        setAssessIcon: function setAssessIcon(question, index) {
            var msg = '',
                answerIcon = '';
            var userAnswer;
            question.userAnswer && question.userAnswer.answers.forEach(function (answer) {
                if (answer.sid == index) return userAnswer = answer;
            });

            if (!userAnswer || userAnswer.assess === undefined || userAnswer.assess == 6) {
                msg = '未作答';
            } else {
                answerIcon = userAnswer.assess == 1 ? 'f-correct' : userAnswer.assess == 2 ? 'f-error' : userAnswer.assess == 3 ? 'f-party_correct' : userAnswer.assess == 4 ? 'f-bandui' : '';
                if (answerIcon) answerIcon = '<span class="f-status ' + answerIcon + '"></span>';
                //                    msg = userAnswer.assess==4?'?':'';
            }
            //                if(msg) msg = '<span class="f-error_txt">'+msg+'</span>';
            return answerIcon || msg;
        },

        // 填空题用户答案
        setFillingAnswer: function setFillingAnswer(userAnswer, index) {
            var result = '';
            userAnswer && userAnswer.answers.forEach(function (answer) {
                if (answer.sid == index) return result = answer.content;
            });
            return result;
        },
        setNewAns: function setNewAns(question, $index) {
            //过滤掉userAnswer 没有 或者分数为0的
            if (question.userAnswer.assess == 6 || question.userAnswer.answers[$index].assess == 6 || question.is_objective == 1) {
                return false;
            }
            var lenAns = question.userAnswer.answers.length - 1;
            var flag = $index > lenAns;
            if (flag) {
                return false;
            }
            this.halfRight = true;
            this.Cright = true;
            this.C_error = true;
            this.handle = $index;
            this.scoreVal = "";
        },
        handleHr: function handleHr(question, ind) {
            this.halfRight = false;
            this.Cright = true;
            this.C_error = true;
            this.scoreVal = (question.question_ref_sorce / question.options.length / 2).toFixed(1) * 1;
            var answers = question.userAnswer;
            this.question.userAnswer = answers;
            this.correctContents = answers;
        },
        handleCr: function handleCr(question, ind) {
            this.Cright = false;
            this.halfRight = true;
            this.C_error = true;
            this.scoreVal = (question.question_ref_sorce / question.options.length).toFixed(1) * 1;
            var answers = question.userAnswer;
            this.question.userAnswer = answers;
            this.correctContents = answers;
        },
        handleCe: function handleCe(question, ind) {
            this.C_error = false;
            this.halfRight = true;
            this.Cright = true;
            this.scoreVal = 0;
            var answers = question.userAnswer;
            this.question.userAnswer = answers;
            this.correctContents = answers;
        },
        checkPrice: function checkPrice(question, ind, val) {
            //输入值
            var maxScore = parseFloat((question.question_ref_sorce / question.options.length).toFixed(1));
            if (val > maxScore) {
                this.$toast('最大分数不能超过该题分值', 'error');
                return false;
            } else if (val < 0) {
                this.$toast('最小分数为0', 'error');
                return false;
            }
            this.scoreVal = val * 1;
            var answers = question.userAnswer;
            this.question.userAnswer = answers;
            this.correctContents = answers;
        },

        //确定
        sentNewSocre: function sentNewSocre(question, ind, val) {
            var maxScore = parseFloat((question.question_ref_sorce / question.options.length).toFixed(1));
            var arrFlag = [0, 0, 0];
            if (val > maxScore) {
                this.$toast('最大分数不能超过该题分值', 'error');
                return false;
            }
            question.userAnswer.answers[ind].score = this.scoreVal; //单个选项的分数改变
            if (this.scoreVal == 0) {
                question.userAnswer.answers[ind].assess = 2; //错
            } else if (this.scoreVal == maxScore) {
                question.userAnswer.answers[ind].assess = 1; //全对
            } else {
                question.userAnswer.answers[ind].assess = 3; //半对
            }
            this.handle = -1;
            this.correctContents.score = 0;
            for (var i = 0, len = this.correctContents.answers.length; i < len; i++) {
                var item = this.correctContents.answers[i];
                if (!item.score) {
                    item.assess == 1 ? item.score = maxScore : item.assess == 3 ? item.score = maxScore / 2 : item.score = 0;
                }
                this.correctContents.score += item.score * 1;
                if (item.assess == 1) {
                    //dui
                    arrFlag[0]++;
                } else if (item.assess == 2) {
                    //cuo
                    arrFlag[1]++;
                } else if (item.assess == 3) {
                    //bandui
                    arrFlag[2]++;
                }
            }
            if (arrFlag[0] == 3) {
                this.correctContents.score = question.question_ref_sorce * 1;
            }
            var flag = question.options.length; //参考答案的长度
            flag == arrFlag[0] ? this.correctContents.assess = 1 : arrFlag[2] > 0 || arrFlag[0] > 0 ? this.correctContents.assess = 3 : this.correctContents.assess = 2;
            this.$emit("correctScore", this.correctContents);
        },
        playedObj: function playedObj(playerObj) {
            this.$emit('playedObj', playerObj);
        }
    }
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__attachments_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__attachments_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__attachments_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tabTopic_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tabTopic_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__tabTopic_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__player_audio_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__player_audio_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__player_audio_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__listenTabTopic_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__listenTabTopic_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__listenTabTopic_vue__);


var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 模仿朗读或简答题


 // 音频组件
 // 听说的tab
/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            myIsPlay: false,
            handle: false,
            scoreVal: '0',
            Cright: true,
            halfRight: true,
            C_error: true,
            correctContents: ''
        };
    },

    props: ['question', 'moduleId', 'parentqtype', 'isShowAnswer', 'playerObj', 'id'],
    components: {
        attachments: __WEBPACK_IMPORTED_MODULE_1__attachments_vue___default.a,
        theAudio: __WEBPACK_IMPORTED_MODULE_3__player_audio_vue___default.a,
        listenTabTopic: __WEBPACK_IMPORTED_MODULE_4__listenTabTopic_vue___default.a,
        tabTopic: __WEBPACK_IMPORTED_MODULE_2__tabTopic_vue___default.a
    },
    created: function created() {
        var _this = this;

        document.body.addEventListener("click", function () {
            _this.handle = false;
        });
    },

    computed: {},
    methods: (_methods = {
        subPlayStatus: function subPlayStatus(val) {
            this.myIsPlay = val;
            console.log(val);
        },

        // 设置得分的标签(assess= undefined或6:未作答  0:未批改 1:对 2:错 3:半对 4:未知  5:批改失败)
        setAssessIcon: function setAssessIcon(userAnswer) {
            var msg = '',
                answerIcon = '';
            if (!userAnswer || userAnswer.assess === undefined || userAnswer.assess == 6) {
                msg = '未作答';
            } else {
                answerIcon = userAnswer.assess == 1 ? 'f-correct' : userAnswer.assess == 2 ? 'f-error' : userAnswer.assess == 3 ? 'f-party_correct' : '';
                if (answerIcon) answerIcon = '<span class="f-status ' + answerIcon + '"></span>';

                msg = userAnswer.assess == 4 ? '未知' : '';
            }
            if (msg) msg = '<span class="f-error_txt">' + msg + '</span>';
            return answerIcon || msg;
        },
        setAssess: function setAssess(userAnswer) {
            var html = '';
            if (userAnswer && userAnswer.score !== undefined) {
                if (userAnswer.assess === 0) {
                    html = '评分中';
                } else if (userAnswer.assess === 5) {
                    html = '批改失败';
                } else if (userAnswer.assess === 4) {
                    html = '<i class="f-status f-unknown"></i> 分';
                } else {
                    html = parseFloat(userAnswer.score) + '分';
                }
            } else {
                html = 0 + '分';
            }
            return html;
        },

        // 格式化答案
        formatAnswers: function formatAnswers(text) {
            var regExp = /#YZSID:[A-Z0-9-_.]+#/; //口头作文id过滤
            var jsgExp = /#JSGF/; //过滤简答题的答案
            if (regExp.test(text)) {
                text = text.replace(regExp, '');
            }
            if (jsgExp.test(text)) {
                text = '答案略';
            }
            return text.replace(/&nbsp;/g, ' ');
        }
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'subPlayStatus', function subPlayStatus(val) {
        this.myIsPlay = val;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'setNewAns', function setNewAns(question) {
        //过滤没有作答的 批改不显示
        if (question.userAnswer == undefined || question.userAnswer.assess == 6 || question.is_objective == 1) {
            return false;
        }
        this.handle = true;
        this.halfRight = true;
        this.Cright = true;
        this.C_error = true;
        this.scoreVal = "";
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'handleHr', function handleHr(question) {
        //半对
        this.halfRight = false;
        this.Cright = true;
        this.C_error = true;
        this.scoreVal = (question.question_ref_sorce / 2).toFixed(1) * 1;
        var answers = question.userAnswer;
        this.question.userAnswer = answers;
        this.correctContents = answers;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'handleCr', function handleCr(question) {
        //对
        this.Cright = false;
        this.halfRight = true;
        this.C_error = true;
        this.scoreVal = question.question_ref_sorce;
        var answers = question.userAnswer;
        this.question.userAnswer = answers;
        this.correctContents = answers;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'handleCe', function handleCe(question) {
        //错
        this.C_error = false;
        this.halfRight = true;
        this.Cright = true;
        this.scoreVal = 0;
        var answers = question.userAnswer;
        this.question.userAnswer = answers;
        this.correctContents = answers;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'checkPrice', function checkPrice(question, val) {
        //输入值
        this.scoreVal = val * 1;
        var maxScore = parseFloat((question.question_ref_sorce / question.options.length).toFixed(1));
        if (val > maxScore) {
            this.$toast('最大分数不能超过该题分值', 'error');
            return false;
        } else if (val < 0) {
            this.$toast('最小分数为0', 'error');
            return false;
        }

        var answers = question.userAnswer;
        this.question.userAnswer = answers;
        this.correctContents = answers;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'sentNewSocre', function sentNewSocre(question, maxScore, val) {
        if (val > maxScore) {
            this.$toast('最大分数不能超过该题分值', 'error');
            return false;
        }
        question.userAnswer.score = this.scoreVal; //一道题的分数改变
        question.userAnswer.answers.score = this.scoreVal; //单个选项的分数改变
        if (this.scoreVal == 0) {
            question.userAnswer.assess = 2; //改变批改状态
        } else if (this.scoreVal == maxScore) {
            question.userAnswer.assess = 1; //改变批改状态
        } else {
            question.userAnswer.assess = 3; //改变批改状态
        }
        this.handle = false;
        this.$emit("correctScore", this.correctContents);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'playedObj', function playedObj(playerObj) {
        this.$emit('playedObj', playerObj);
    }), _methods)
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attachments_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attachments_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__attachments_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tabTopic_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tabTopic_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tabTopic_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 判断题

 // 附件
/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },

    props: ['question', 'moduleId', 'parentqtype', 'isShowAnswer', 'playerObj'],
    components: {
        attachments: __WEBPACK_IMPORTED_MODULE_0__attachments_vue___default.a,
        tabTopic: __WEBPACK_IMPORTED_MODULE_1__tabTopic_vue___default.a
    },
    mounted: function mounted() {// 同v1.*的ready

    },

    computed: {},
    methods: {
        // 设置得分的标签(assess= undefined或6:未作答  0:未批改 1:对 2:错 3:半对 4:未知  5:批改失败)
        setAssessIcon: function setAssessIcon(userAnswer) {
            var msg = '',
                answerIcon = '';
            if (!userAnswer || userAnswer.assess === undefined || userAnswer.assess == 6) {
                msg = '未作答';
            } else {
                answerIcon = userAnswer.assess == 1 ? 'f-correct' : userAnswer.assess == 2 ? 'f-error' : userAnswer.assess == 3 ? 'f-party_correct' : '';
                if (answerIcon) answerIcon = '<span class="f-status ' + answerIcon + '"></span>';

                msg = userAnswer.assess == 4 ? '未知' : '';
            }
            if (msg) msg = '<span class="f-error_txt">' + msg + '</span>';
            return answerIcon || msg;
        },
        setAssess: function setAssess(userAnswer) {
            var html = '';
            if (userAnswer && userAnswer.score !== undefined) {
                if (userAnswer.assess === 0) {
                    html = '评分中';
                } else if (userAnswer.assess === 5) {
                    html = '批改失败';
                } else if (userAnswer.assess === 4) {
                    html = '<i class="f-status f-unknown"></i> 分';
                } else {
                    html = parseFloat(userAnswer.score) + '分';
                }
            } else {
                html = 0 + '分';
            }
            return html;
        },

        // 格式化答案
        formatAnswers: function formatAnswers(text) {
            var regExp = /#YZSID:[A-Z0-9-_.]+#/; //口头作文id过滤
            var jsgExp = /#JSGF/; //过滤简答题的答案
            if (regExp.test(text)) {
                text = text.replace(regExp, '');
            }
            if (jsgExp.test(text)) {
                text = '答案略';
            }
            return text.replace(/&nbsp;/g, ' ');
        },

        //设置答案
        setAnswers: function setAnswers(answers) {
            return answers.indexOf('1') ? '错误' : '正确';
        },
        playedObj: function playedObj(playerObj) {
            this.$emit('playedObj', playerObj);
        }
    }
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			topicActive: '1'
		};
	},

	props: ['infoAnswer', 'listenTextModule', 'qtype'],
	methods: {
		tabListen: function tabListen(index) {
			this.topicActive = index;
		},
		setRefAnswer: function setRefAnswer(options, ref_info) {
			var _this = this;
			var result = '';
			for (var i = 0; i < options.length; i++) {
				var option = options[i];
				if (ref_info) {
					// 不是参考答案
					for (var j = 0; j < ref_info.answers.length; j++) {
						var answer = ref_info.answers[j];
						if (answer == option.id) {
							result += String.fromCharCode(65 + i) + ' ';
						}
					}
				}
			}
			return result;
		},

		// 格式化答案
		formatAnswers: function formatAnswers(text) {
			var regExp = /#YZSID:[A-Z0-9-_.]+#/; //口头作文id过滤
			var jsgExp = /#JSGF/; //过滤简答题的答案
			if (regExp.test(text)) {
				text = text.replace(regExp, '');
			}
			if (jsgExp.test(text)) {
				text = '答案略';
			}
			return text.replace(/&nbsp;/g, ' ');
		}
	}
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attachments_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attachments_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__attachments_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tabTopic_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tabTopic_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tabTopic_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listenTabTopic_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listenTabTopic_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__listenTabTopic_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 多选题
 // 附件
 // 附件
 // 听说的tab
/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },

    props: ['question', 'moduleId', 'parentqtype', 'isShowAnswer', 'playerObj'],
    components: {
        attachments: __WEBPACK_IMPORTED_MODULE_0__attachments_vue___default.a,
        tabTopic: __WEBPACK_IMPORTED_MODULE_1__tabTopic_vue___default.a,
        listenTabTopic: __WEBPACK_IMPORTED_MODULE_2__listenTabTopic_vue___default.a
    },
    mounted: function mounted() {// 同v1.*的ready

    },

    computed: {},
    methods: {
        // 设置得分的标签(assess= undefined或6:未作答  0:未批改 1:对 2:错 3:半对 4:未知  5:批改失败)
        setAssessIcon: function setAssessIcon(userAnswer) {
            var msg = '',
                answerIcon = '';
            if (!userAnswer || userAnswer.assess === undefined || userAnswer.assess == 6) {
                msg = '未作答';
            } else {
                answerIcon = userAnswer.assess == 1 ? 'f-correct' : userAnswer.assess == 2 ? 'f-error' : userAnswer.assess == 3 ? 'f-party_correct' : '';
                if (answerIcon) answerIcon = '<span class="f-status ' + answerIcon + '"></span>';
                msg = userAnswer.assess == 4 ? '未知' : '';
            }
            if (msg) msg = '<span class="f-error_txt">' + msg + '</span>';
            return answerIcon || msg;
        },
        setAssess: function setAssess(userAnswer) {
            var html = '';
            if (userAnswer && userAnswer.score !== undefined) {
                if (userAnswer.assess === 0) {
                    html = '评分中';
                } else if (userAnswer.assess === 5) {
                    html = '批改失败';
                } else if (userAnswer.assess === 4) {
                    html = '<i class="f-status f-unknown"></i> 分';
                } else {
                    html = parseFloat(userAnswer.score) + '分';
                }
            } else {
                html = 0 + '分';
            }
            return html;
        },

        // 格式化答案
        formatAnswers: function formatAnswers(text) {
            var regExp = /#YZSID:[A-Z0-9-_.]+#/; //口头作文id过滤
            var jsgExp = /#JSGF/; //过滤简答题的答案
            if (regExp.test(text)) {
                text = text.replace(regExp, '');
            }
            if (jsgExp.test(text)) {
                text = '答案略';
            }
            return text.replace(/&nbsp;/g, ' ');
        },
        setRefAnswer: function setRefAnswer(options, ref_info) {
            var _this = this;
            var result = '';
            for (var i = 0; i < options.length; i++) {
                var option = options[i];
                if (ref_info) {
                    // 不是参考答案
                    for (var j = 0; j < ref_info.answers.length; j++) {
                        var answer = ref_info.answers[j];
                        if (answer == option.id) {
                            result += String.fromCharCode(65 + i) + ' ';
                        }
                    }
                }
            }

            return result;
        },

        // 用户答案选项
        setUserAnswer: function setUserAnswer(options, userAnswer) {
            var _this = this;
            var result = '';
            for (var i = 0; i < options.length; i++) {
                var option = options[i];
                if (userAnswer) {
                    // 不是参考答案
                    var isCorrect = false;

                    for (var j = 0; j < userAnswer.answers.length; j++) {
                        var answer = userAnswer.answers[j];
                        if (_this.moduleId == 15) {
                            // 答案类型(1:音频文件 2:选项ID 3:填空题答案)
                            if (answer.answerType == 2 && answer.content == option.id) {
                                result += String.fromCharCode(65 + i) + ' ';
                            }
                        } else if (_this.moduleId == 124) {
                            // 答案类型(1:字符串 2:音频文件)
                            if (answer.content == option.id) {
                                result += String.fromCharCode(65 + i) + ' ';
                            }
                        }
                    }
                }
            }

            return result;
        },
        playedObj: function playedObj(playerObj) {
            this.$emit('playedObj', playerObj);
        }
    }
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tabTopic_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tabTopic_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tabTopic_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__attachments_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__attachments_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__attachments_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__singleChoice_vue__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__singleChoice_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__singleChoice_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__multipleChoice_vue__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__multipleChoice_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__multipleChoice_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filling_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filling_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__filling_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__allFilling_vue__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__allFilling_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__allFilling_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shortanswer_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shortanswer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__shortanswer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__imitation_vue__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__imitation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__imitation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__judge_vue__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__judge_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__judge_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 阅读理解,该题型包含小题，小题类型有：1单选图、6简答题、7模仿朗读
 // 附件
 // 附件
 // 1单选题
 // 2多选题
 // 3填空题
 // 4完形填空
 // 6简答题
 // 7模仿朗读or简答题
 // 8判断题

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },

    props: ['moduleId', 'question', 'isShowAnswer', 'playerObj'],
    components: {
        attachments: __WEBPACK_IMPORTED_MODULE_1__attachments_vue___default.a,
        singleChoice: __WEBPACK_IMPORTED_MODULE_2__singleChoice_vue___default.a,
        multipleChoice: __WEBPACK_IMPORTED_MODULE_3__multipleChoice_vue___default.a,
        filling: __WEBPACK_IMPORTED_MODULE_4__filling_vue___default.a,
        allFilling: __WEBPACK_IMPORTED_MODULE_5__allFilling_vue___default.a,
        shortanswer: __WEBPACK_IMPORTED_MODULE_6__shortanswer_vue___default.a,
        imitation: __WEBPACK_IMPORTED_MODULE_7__imitation_vue___default.a,
        judge: __WEBPACK_IMPORTED_MODULE_8__judge_vue___default.a,
        tabTopic: __WEBPACK_IMPORTED_MODULE_0__tabTopic_vue___default.a
    },
    mounted: function mounted() {// 同v1.*的ready

    },

    computed: {
        // debugger;
    },
    methods: {
        playedObj: function playedObj(playerObj) {
            this.$emit('playedObj', playerObj);
        },
        correctScore: function correctScore(_correctScore) {
            this.$emit('correctScore', _correctScore);
        }
    }
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attachments_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attachments_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__attachments_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__alertBigImg_vue__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__alertBigImg_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__alertBigImg_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__player_audio_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__player_audio_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__player_audio_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tabTopic_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tabTopic_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__tabTopic_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__listenTabTopic_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__listenTabTopic_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__listenTabTopic_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 简答题


 // 音频组件
 // 在线的tab 
 // 听说的tab
/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            myIsPlay: false,
            handle: false,
            scoreVal: 0,
            Cright: true,
            halfRight: true,
            C_error: true,
            correctContents: '',
            bigImgShow: false,
            imgUrl: '',
            imgFlag: false
        };
    },

    props: ['page', 'question', 'parentqtype', 'isShowAnswer', 'moduleId', 'playerObj', 'id', 'padShow', 'underlineF'],
    components: {
        attachments: __WEBPACK_IMPORTED_MODULE_0__attachments_vue___default.a,
        theAudio: __WEBPACK_IMPORTED_MODULE_2__player_audio_vue___default.a,
        bigImgShow: __WEBPACK_IMPORTED_MODULE_1__alertBigImg_vue___default.a,
        tabTopic: __WEBPACK_IMPORTED_MODULE_3__tabTopic_vue___default.a,
        listenTabTopic: __WEBPACK_IMPORTED_MODULE_4__listenTabTopic_vue___default.a
    },
    created: function created() {
        var _this = this;

        document.body.addEventListener("click", function () {
            _this.handle = false;
        });
    },

    computed: {},
    methods: {
        // 设置得分的标签(assess= undefined或6:未作答  0:未批改 1:对 2:错 3:半对 4:未知  5:批改失败)
        setAssessIcon: function setAssessIcon(userAnswer) {
            var msg = '',
                answerIcon = '';
            if (!userAnswer || userAnswer.assess === undefined || userAnswer.assess == 6) {
                msg = '未作答';
            } else {
                answerIcon = userAnswer.assess == 1 ? 'f-correct' : userAnswer.assess == 2 ? 'f-error' : userAnswer.assess == 3 ? 'f-party_correct' : userAnswer.assess == 4 ? 'f-bandui' : '';
                if (answerIcon) answerIcon = '<span class="f-status ' + answerIcon + '"></span>';
            }
            return answerIcon || msg;
        },
        setAssess: function setAssess(userAnswer) {
            var html = '';
            if (userAnswer && userAnswer.score !== undefined) {
                if (userAnswer.assess === 0) {
                    html = '评分中';
                } else if (userAnswer.assess === 5) {
                    html = '批改失败';
                } else if (userAnswer.assess === 4) {
                    html = '<i class="f-status f-unknown"></i> 分';
                } else {
                    html = parseFloat(userAnswer.score) + '分';
                }
            } else {
                html = 0 + '分';
            }
            return html;
        },

        // 格式化答案
        formatAnswers: function formatAnswers(text) {
            var regExp = /#YZSID:[A-Z0-9-_.]+#/; //口头作文id过滤
            var jsgExp = /#JSGF/; //过滤简答题的答案
            if (regExp.test(text)) {
                text = text.replace(regExp, '');
            }
            if (jsgExp.test(text)) {
                text = '答案略';
            }
            return text.replace(/&nbsp;/g, ' ');
        },
        matchUrl: function matchUrl(val) {
            var reg = /\S.[jpg|png|jpeg]$/;
            if (reg.test(val)) {
                this.bigImgShow = true;
                this.imgUrl = val;
                return '<img src=' + val + ' class="width_20">';
            } else {
                return val;
            }
        },
        imgFun: function imgFun(val) {
            this.imgFlag = true;
        },
        imgBigShow: function imgBigShow(val) {
            this.imgFlag = val;
        },
        setNewAns: function setNewAns(question) {
            //过滤没有作答的 批改不显示
            if (question.userAnswer.assess == 6 || question.is_objective == 1) {
                return false;
            }
            this.handle = !this.handle;
            this.scoreVal = 0;
        },
        handleHr: function handleHr(question) {
            //半对
            this.halfRight = false;
            this.Cright = true;
            this.C_error = true;
            this.scoreVal = (question.question_ref_sorce / 2).toFixed(1) * 1;
            var answers = question.userAnswer;
            this.question.userAnswer = answers;
            this.correctContents = answers;
        },
        handleCr: function handleCr(question) {
            //对
            this.Cright = false;
            this.halfRight = true;
            this.C_error = true;
            this.scoreVal = question.question_ref_sorce;
            var answers = question.userAnswer;
            this.question.userAnswer = answers;
            this.correctContents = answers;
        },
        handleCe: function handleCe(question) {
            //错
            this.C_error = false;
            this.halfRight = true;
            this.Cright = true;
            this.scoreVal = 0;
            var answers = question.userAnswer;
            this.question.userAnswer = answers;
            this.correctContents = answers;
        },
        checkPrice: function checkPrice(question, val) {
            //输入值
            this.scoreVal = val * 1;
            var maxScore = parseFloat((question.question_ref_sorce / question.options.length).toFixed(1));
            if (val > maxScore) {
                this.$toast('最大分数不能超过该题分值', 'error');
                return false;
            } else if (val < 0) {
                this.$toast('最小分数为0', 'error');
                return false;
            }
            var answers = question.userAnswer;
            this.question.userAnswer = answers;
            this.correctContents = answers;
        },

        //确定
        sentNewSocre: function sentNewSocre(question, maxScore, val) {

            if (val > maxScore) {
                this.$toast('最大分数不能超过该题分值', 'error');
                return false;
            }
            question.userAnswer.score = this.scoreVal; //一道题的分数改变
            question.userAnswer.answers.score = this.scoreVal; //单个选项的分数改变
            if (this.scoreVal == 0) {
                question.userAnswer.assess = 2; //改变批改状态
            } else if (this.scoreVal == maxScore) {
                question.userAnswer.assess = 1; //改变批改状态
            } else {
                question.userAnswer.assess = 3;
            }
            this.handle = false;
            this.$emit("correctScore", this.correctContents);
        },
        subPlayStatus: function subPlayStatus(val) {
            this.myIsPlay = val;
            console.log(val);
        },
        playedObj: function playedObj(playerObj) {
            this.$emit('playedObj', playerObj);
        }
    }
});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attachments_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attachments_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__attachments_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tabTopic_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tabTopic_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tabTopic_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listenTabTopic_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listenTabTopic_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__listenTabTopic_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 单选题
 // 附件
 // 附件
 // 听说的tab
/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },

    props: ['question', 'moduleId', 'parentqtype', 'isShowAnswer', 'playerObj'],
    components: {
        attachments: __WEBPACK_IMPORTED_MODULE_0__attachments_vue___default.a,
        tabTopic: __WEBPACK_IMPORTED_MODULE_1__tabTopic_vue___default.a,
        listenTabTopic: __WEBPACK_IMPORTED_MODULE_2__listenTabTopic_vue___default.a
    },
    mounted: function mounted() {// 同v1.*的ready

    },

    computed: {},
    methods: {
        // 设置得分的标签(assess= undefined或6:未作答  0:未批改 1:对 2:错 3:半对 4:未知  5:批改失败)
        setAssessIcon: function setAssessIcon(userAnswer) {
            var msg = '',
                answerIcon = '';
            if (!userAnswer || userAnswer.assess === undefined || userAnswer.assess == 6) {
                msg = '未作答';
            } else {
                answerIcon = userAnswer.assess == 1 ? 'f-correct' : userAnswer.assess == 2 ? 'f-error' : userAnswer.assess == 3 ? 'f-party_correct' : '';
                if (answerIcon) answerIcon = '<span class="f-status ' + answerIcon + '"></span>';

                msg = userAnswer.assess == 4 ? '未知' : '';
            }
            if (msg) msg = '<span class="f-error_txt">' + msg + '</span>';
            return answerIcon || msg;
        },
        setAssess: function setAssess(userAnswer) {
            var html = '';
            if (userAnswer && userAnswer.score !== undefined) {
                if (userAnswer.assess === 0) {
                    html = '评分中';
                } else if (userAnswer.assess === 5) {
                    html = '批改失败';
                } else if (userAnswer.assess === 4) {
                    html = '<i class="f-status f-unknown"></i> 分';
                } else {
                    html = parseFloat(userAnswer.score) + '分';
                }
            } else {
                html = 0 + '分';
            }
            return html;
        },

        // 格式化答案
        formatAnswers: function formatAnswers(text) {
            var regExp = /#YZSID:[A-Z0-9-_.]+#/; //口头作文id过滤
            var jsgExp = /#JSGF/; //过滤简答题的答案
            if (regExp.test(text)) {
                text = text.replace(regExp, '');
            }
            if (jsgExp.test(text)) {
                text = '答案略';
            }
            return text.replace(/&nbsp;/g, ' ');
        },

        // 用户答案选项
        setUserAnswer: function setUserAnswer(options, userAnswer) {
            var _this = this;
            var result = '';
            for (var i = 0; i < options.length; i++) {
                var option = options[i];
                if (userAnswer) {
                    // 不是参考答案
                    var isCorrect = false;

                    for (var j = 0; j < userAnswer.answers.length; j++) {
                        var answer = userAnswer.answers[j];
                        if (_this.moduleId == 15) {
                            // 答案类型(1:音频文件 2:选项ID 3:填空题答案)
                            if (answer.answerType == 2 && answer.content == option.id) {
                                result += String.fromCharCode(65 + i) + ' ';
                            }
                        } else if (_this.moduleId == 124) {
                            // 答案类型(1:字符串 2:音频文件)
                            if (answer.content == option.id) {
                                result += String.fromCharCode(65 + i) + ' ';
                            }
                        }
                    }
                }
            }

            return result;
        },
        playedObj: function playedObj(playerObj) {
            this.$emit('playedObj', playerObj);
        }
    }
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__player_video_vue__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__player_video_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__player_video_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			topicActive: '1',
			videoP: true,
			myIsPlay: false,
			audio: null,
			explainsTags: [],
			emptyFlag: true
		};
	},

	props: ['infoAnswer', 'knowledgePoints', 'explains', 'tags', 'skillPoints', 'qtype', 'isObject'],
	components: {
		videoletv: __WEBPACK_IMPORTED_MODULE_0__player_video_vue___default.a
	},
	created: function created() {
		if (this.infoAnswer) {
			this.topicActive = 1;
		} else if (this.knowledgePoints.length > 0) {
			this.topicActive = 2;
		} else if (this.explains[0]) {
			this.topicActive = 3;
		} else if (this.tags) {
			this.topicActive = 4;
		} else if (this.skillPoints.length > 0) {
			this.topicActive = 5;
		} else {
			this.emptyFlag = false;
		}
		this.correctFlag = this.correctFill;
	},

	methods: {
		topicAct: function topicAct(index) {
			this.topicActive = index;
		},
		videoSrc: function videoSrc(item) {
			var src = item.substr(7);
			// return 'http://yuntv.letv.com/bcloud.html?uu=2bfc338ed7&vu='+ src +'&width=300&height=150&&pu=B6999F08EC'
			return 'pu=B6999F08EC&uu=2bfc338ed7&vu=' + src + '&auto_play=1&width=656&height=504';
		},
		setAnswers: function setAnswers(answers) {
			return answers.indexOf('1') ? '错误' : '正确';
		},
		setRefAnswer: function setRefAnswer(options, ref_info) {
			var _this = this;
			var result = '';
			for (var i = 0; i < options.length; i++) {
				var option = options[i];
				if (ref_info) {
					// 不是参考答案
					for (var j = 0; j < ref_info.answers.length; j++) {
						var answer = ref_info.answers[j];
						if (answer == option.id) {
							result += String.fromCharCode(65 + i) + ' ';
						}
					}
				}
			}
			return result;
		},
		setShortAnswer: function setShortAnswer(item) {
			if (item.indexOf('[') == 0 || item.indexOf('{') == 0) {
				var data = JSON.parse(item);
				if (data instanceof Array) {
					return data.join("/");
				} else {
					if (data.instead || data.add || data.isDelete) {
						var strHtml = '';
						if (data.instead) {
							strHtml += '改为' + data.instead + '/';
						}
						if (data.add) {
							strHtml += '单词前加' + data.add + '/';
						}
						if (data.isDelete) {
							strHtml += '删除' + '/';
						}
						return strHtml.replace(/\/$/g, '');
					}
				}
			} else {
				return item;
			}
		},

		player: function player() {
			this.audio = document.querySelector('audio');
			this.audio.play();
			this.myIsPlay = true;
			var _this = this;
			this.audio.addEventListener('ended', function () {
				_this.myIsPlay = false;
			});
		},
		videoPlayer: function videoPlayer() {
			this.videoP = false;
		}
	}
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fetch__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_question_exampaper_vue__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_question_exampaper_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_question_exampaper_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(28);

//
//
//
//
//
//
//

 // 接口
 // 所有题型组件


/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		exampaper: __WEBPACK_IMPORTED_MODULE_2__components_question_exampaper_vue___default.a
	},
	data: function data() {
		return {
			page: 'selectOnlinePaper', // 当前页面
			versionId: '', // 试卷ID 	4613335007164703262
			accessToken: '',
			clientId: '',
			brandId: '',
			webloading: true,
			exampaperData: {}, // 试卷信息
			moduleId: 124,
			thirdParty: true,
			doworkTime: ''
		};
	},
	created: function created() {
		var _this = this;

		this.$nextTick(function () {
			_this.getData();
			_this.setCrumb('在线作答预览');
		});
	},

	watch: {
		'$route': function $route(newValue, oldValue) {
			this.getData();
		}
	},
	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['setCrumb', 'setUser']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['getUser']), {
		getData: function getData() {
			var _this2 = this;

			var params = this.$route.params;
			var $this = this;
			this.webloading = true;
			if (params.userId) {
				this.thirdParty = false;
			}
			__WEBPACK_IMPORTED_MODULE_1__fetch__["a" /* default */].getOnlineExamination({ versionId: params.versionId }).then(function (res) {
				if (!res) {
					return false;
				}
				_this2.exampaperData = res.data;
				// setTimeout(()=>{
				// 	$this.webloading=false;
				// }, 1000)
			}, function (err) {
				console.log(err);
			});
		}
	})
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      src: ''
    };
  },

  props: ['useInfo', 'userScore', 'userRank'],
  created: function created() {},

  methods: {
    toSex: function toSex(sex) {
      return sex == 1 ? "../../../assets/img/boy.png" : "../../../assets/img/girl.png";
    }
  }
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            isShowMenu: false,
            isShowTop: false,
            pageHeight: { 'heigth': '600px' }
        };
    },
    created: function created() {
        var _this = this;

        this.$nextTick(function () {
            window.addEventListener('load', _this.windowOnLoad);
        });
    },

    watch: {
        '$route': function $route(newValue, oldValue) {
            // this.isShowMenu = newValue.path !='/' && newValue.path != '/home' && newValue.path != '/class' && newValue.name != 'personMsg'?true:false;
            // this.isShowTop = newValue.path =='/ranks'?false:true;
        }
    },
    methods: {
        // //监听页面刷新事件
        // windowOnLoad(){
        //     this.isShowMenu = this.$route.path !='/' && this.$route.path !='/home' && this.$route.path !='/class' && this.$route.name !='personMsg'?true:false;
        //     this.isShowTop = this.$route.path =='/ranks'?false:true;
        // },
        // setPageHeight(){
        //     this.isShowMenu = this.$route.path !='/' && this.$route.path !='/home' && this.$route.path !='/class' && this.$route.path !='/ForgotPwd'?true:false;
        // },
        // setHeight(){
        //     let pageHeight = 0;
        //     let screenHeight= document.body.offsetHeight
        //     if(this.isShowMenu) {
        //         pageHeight = screenHeight - 120;
        //     } else {
        //         pageHeight = screenHeight - 60;
        //     }
        //     this.pageHeight = {heigth: pageHeight+'px'};
        // }
    }
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var grads = [{ id: 1101, periodid: '1001', name: '一年级' }, { id: 1102, periodid: '1001', name: '二年级' }, { id: 1103, periodid: '1001', name: '三年级' }, { id: 1104, periodid: '1001', name: '四年级' }, { id: 1105, periodid: '1001', name: '五年级' }, { id: 1106, periodid: '1001', name: '六年级' }, { id: 1107, periodid: '1003', name: '七年级' }, { id: 1108, periodid: '1003', name: '八年级' }, { id: 1109, periodid: '1003', name: '九年级' }, { id: 1111, periodid: '1005', name: '高一' }, { id: 1112, periodid: '1005', name: '高二' }, { id: 1113, periodid: '1005', name: '高三' }];

/* harmony default export */ __webpack_exports__["default"] = (grads);

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filter__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);


var Vue = __webpack_require__(3);
var qs = __webpack_require__(272);

/* harmony default export */ __webpack_exports__["a"] = (function (url, data, method, customerQuery, isFormData) {
	// Vue.http.options.emulateJSON = true;

	var _this = this;
	var query = {
		clientId: __WEBPACK_IMPORTED_MODULE_1__config__["b" /* clientId */],
		brandId: __WEBPACK_IMPORTED_MODULE_1__config__["c" /* brandId */]
	};
	var Authorization = window.localStorage.user ? JSON.parse(window.localStorage.user).userId : data.userId;
	if (!data) {
		data = {};
	}
	if ('post' == method) {
		data.clientId = __WEBPACK_IMPORTED_MODULE_1__config__["b" /* clientId */];
		data.brandId = __WEBPACK_IMPORTED_MODULE_1__config__["c" /* brandId */];
	}
	if (data.userId && data.clientId) {
		query = {};
	}

	if (!customerQuery) {
		__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.common['Authorization'] = 'Basic ' + window.btoa(Authorization + ':');
		__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.withCredentials = true;
	}

	// Axios.defaults.headers.common['Authorization'] = 'Basic '+window.btoa( Authorization +':');
	// Axios.defaults.withCredentials = true; 
	return __WEBPACK_IMPORTED_MODULE_2_axios___default.a[method](url + '?' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__filter__["stringParam"])(query), method == 'get' ? { params: data } : isFormData ? qs.stringify(data) : data).then(function (res) {
		var data = res.data;
		if (data.errcode == 10008 || data.errcode == 10009 || data.errcode == 17 || data.errcode == 18 || data.errcode == 26 || data.errcode == 27 || data.errcode == 15 || data.errcode == 401) {
			return false;
		}
		if (data.errcode) {
			if (data.msg.indexOf('没有找到相应的教学顾问相关信息') < 0) {
				Vue.prototype.$toast(data.msg, 'error');
			}
			return false;
		}
		return data;
	}).catch(function (err) {
		return err;
	});
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_vue__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_index_css__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_scss_style_scss__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_scss_style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_scss_style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__filter__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__unit_toast_js__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__unit_toast_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__unit_toast_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__seo__ = __webpack_require__(104);














__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui__["Popover"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10__unit_toast_js___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui__["DatePicker"]);
__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_7__filter__).forEach(function (k) {
  __WEBPACK_IMPORTED_MODULE_1_vue___default.a.filter(k, __WEBPACK_IMPORTED_MODULE_7__filter__[k]);
});

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  // mode: 'history',
  routes: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  }
});
router.beforeEach(function (to, from, next) {
  document.title = __WEBPACK_IMPORTED_MODULE_11__seo__["a" /* default */][to.name];
  // if (to.fullPath.indexOf('/web') > -1) {
  //   if (to.name === 'home') {
  //     if (window.localStorage.user) {
  //       next()
  //     } else {
  //       next({path: '/web/login'})
  //     }
  //   }
  // }
  next();
});
new __WEBPACK_IMPORTED_MODULE_1_vue___default.a({
  router: router,
  store: __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_3__App_vue___default.a);
  }
}).$mount('#app');

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutations_types__ = __webpack_require__(14);


/* harmony default export */ __webpack_exports__["a"] = ({
		setCrumb: Write(__WEBPACK_IMPORTED_MODULE_0__mutations_types__["q" /* WRITE_CRUMB */]),
		removeCrumb: Write(__WEBPACK_IMPORTED_MODULE_0__mutations_types__["s" /* CLEAN_CRUMB */]),
		setWorks: Write(__WEBPACK_IMPORTED_MODULE_0__mutations_types__["n" /* WRITE_WORKS */]),
		removeWorks: Write(__WEBPACK_IMPORTED_MODULE_0__mutations_types__["o" /* CLEAN_WORKS */]),
		setUser: Write(__WEBPACK_IMPORTED_MODULE_0__mutations_types__["k" /* WRITE_USER */]),
		removeUser: Write(__WEBPACK_IMPORTED_MODULE_0__mutations_types__["l" /* CLEAN_USER */]),
		setSuject: Write(__WEBPACK_IMPORTED_MODULE_0__mutations_types__["h" /* WRITE_SUBJECT */]),
		removeSubject: Write(__WEBPACK_IMPORTED_MODULE_0__mutations_types__["i" /* CLEAN_SUBJECT */]),
		setToast: Write(__WEBPACK_IMPORTED_MODULE_0__mutations_types__["e" /* WRITE_TOAST */]),
		cleanToast: Write(__WEBPACK_IMPORTED_MODULE_0__mutations_types__["f" /* CLEAN_TOAST */]),
		setCatalog: Write(__WEBPACK_IMPORTED_MODULE_0__mutations_types__["b" /* WRITE_CATALOG */]),
		cleanCatalog: Write(__WEBPACK_IMPORTED_MODULE_0__mutations_types__["c" /* CLEAN_CATALOG */])
});

function Write(type) {
		return function (_ref) {
				for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
						args[_key - 1] = arguments[_key];
				}

				var commit = _ref.commit;
				return commit.apply(undefined, [type].concat(args));
		};
}
function Ready(type) {
		return function (_ref2) {
				for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
						args[_key2 - 1] = arguments[_key2];
				}

				var dispatch = _ref2.dispatch;

				var res = dispatch.apply(undefined, [type].concat(args));
				return res;
		};
}

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	getWorks: function getWorks(state) {
		return state.works.works;
	},
	getCrumb: function getCrumb(state) {
		return state.crumb.crumb;
	},
	getUser: function getUser(state) {
		return state.user.user;
	},
	getSubject: function getSubject(state) {
		return state.subject.subject;
	},
	getCatalog: function getCatalog(state) {
		return state.catalog.catalog;
	},
	showToast: function showToast(state) {
		return state.toast.toast;
	}
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations_types__ = __webpack_require__(14);


var _mutations;



var state = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__mutations_types__["a" /* CATALOG */], JSON.parse(window.sessionStorage.getItem(__WEBPACK_IMPORTED_MODULE_1__mutations_types__["a" /* CATALOG */]) || '[]'));

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_types__["b" /* WRITE_CATALOG */], function (state, obj) {
	state[__WEBPACK_IMPORTED_MODULE_1__mutations_types__["a" /* CATALOG */]] = obj;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_types__["c" /* CLEAN_CATALOG */], function (state) {
	state[__WEBPACK_IMPORTED_MODULE_1__mutations_types__["a" /* CATALOG */]] = [];
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	mutations: mutations
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations_types__ = __webpack_require__(14);


var _mutations;



var state = {
	crumb: JSON.parse(window.sessionStorage.getItem(__WEBPACK_IMPORTED_MODULE_1__mutations_types__["p" /* CRUMB */]) || '[]')
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_types__["q" /* WRITE_CRUMB */], function (state, title) {
	var url = window.location.href;
	var arr = [title, url];
	var flag = true;
	state.crumb.find(function (item, index) {
		if (item && item[0] == title) {
			state.crumb.splice(index + 1);
			flag = false;
		}
	});
	if (flag) {
		state.crumb.push(arr);
	}
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_types__["r" /* READ_CRUMB */], function (state) {
	return state.crumb;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_types__["s" /* CLEAN_CRUMB */], function (state) {
	return state.crumb = [];
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	mutations: mutations
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations_types__ = __webpack_require__(14);


var _mutations;



var state = {
	subject: JSON.parse(window.sessionStorage.getItem(__WEBPACK_IMPORTED_MODULE_1__mutations_types__["g" /* SUBJECT */]) || '[]')
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_types__["h" /* WRITE_SUBJECT */], function (state, obj) {
	state.subject = obj;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_types__["i" /* CLEAN_SUBJECT */], function (state) {
	state.subject = [];
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	mutations: mutations
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations_types__ = __webpack_require__(14);


var _mutations;



var state = {
	toast: JSON.parse(window.sessionStorage.getItem(__WEBPACK_IMPORTED_MODULE_1__mutations_types__["d" /* TOAST */]) || '{}')
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_types__["e" /* WRITE_TOAST */], function (state, obj) {
	state.toast = obj;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_types__["f" /* CLEAN_TOAST */], function (state) {
	state.toast = {};
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	mutations: mutations
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations_types__ = __webpack_require__(14);


var _mutations;



var state = {
	user: JSON.parse(window.localStorage.getItem(__WEBPACK_IMPORTED_MODULE_1__mutations_types__["j" /* USER */]) || '{}')
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_types__["k" /* WRITE_USER */], function (state, obj) {
	state.user = obj;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_types__["l" /* CLEAN_USER */], function (state) {
	state.user = [];
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	mutations: mutations
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations_types__ = __webpack_require__(14);



var _mutations;



var state = {
	works: JSON.parse(window.sessionStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__mutations_types__["m" /* WORKS */]) || '{}')
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types__["n" /* WRITE_WORKS */], function (state, obj) {
	__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state.works, obj);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types__["o" /* CLEAN_WORKS */], function (state) {
	state.works = {};
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	mutations: mutations
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_dist_logger__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_dist_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex_dist_logger__);



var localStoragePlugin = function localStoragePlugin(store) {
    store.subscribe(function (mutation, state) {
        var STORAGE_KEY = mutation.type.split('_')[1];
        if (STORAGE_KEY === 'user') {
            window.localStorage.setItem(STORAGE_KEY, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state[STORAGE_KEY][STORAGE_KEY]));
        } else {
            window.sessionStorage.setItem(STORAGE_KEY, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state[STORAGE_KEY][STORAGE_KEY]));
        }
    });
};

/* harmony default export */ __webpack_exports__["a"] = ( false ? [createLogger(), localStoragePlugin] : [localStoragePlugin]);

/***/ })
],[259]);


// WEBPACK FOOTER //
// static/js/app.13ba76f97956721a1bf0.js